import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  Unit_instanceat14thlj150z as Unit_instance,
  contentEquals2jbsaphs7gxql as contentEquals,
  contentHashCode33l4yznfe2pz3 as contentHashCode,
  intArrayIterator15bt84fheeonh as intArrayIterator,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID7hggqo3abtya as VOID,
  contentEquals379bkuxwxaiqz as contentEquals_0,
  contentHashCode2dpr73siofp13 as contentHashCode_0,
  floatArrayIteratortsocm2kbztk as floatArrayIterator,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  reverse2o3etdk6ug8y7 as reverse,
  copyOfq9pcgcgbldck as copyOf,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  isFloatArrayjjscnqphw92j as isFloatArray,
  createThis2j2avj17cvnv2 as createThis,
  takeg3iw3d2yd8b4 as take,
  equals2au1ep9vhcato as equals,
  KtList3hktaavzmj137 as KtList,
  isInterface3d6p8outrmvmk as isInterface,
  StringBuildermazzzhj6kkai as StringBuilder,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  Collection1k04j3hzsbod0 as Collection,
  isIntArrayeijsubfngq38 as isIntArray,
  copyOf3rutauicler23 as copyOf_0,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
  take8rd02inxauy8 as take_0,
  copyOfgossjg6lh6js as copyOf_1,
  isDoubleArray1wyh4nyf7pjxn as isDoubleArray,
  takei63g8tyo7wy9 as take_1,
  asList2ho2pewtsfvv as asList,
  compareTo3ankvs086tmwq as compareTo,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  isArray1hxjqtqy632bc as isArray,
  toSet2orjxp16sotqu as toSet,
  toList3jhuyej2anx2q as toList,
  until1jbpn0z3f8lbg as until,
  ArrayList3it5z8td81qkl as ArrayList,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  to2cs3ny02qtbcb as to,
  KtMap140uvy3s5zad8 as KtMap,
  hashCodeq5arwsb9dgti as hashCode,
  MutableIterablez3x4ksk1fmrm as MutableIterable,
  AbstractMutableSetthfi6jds1k2h as AbstractMutableSet,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  toMutableSetjdpdbr9jsqq8 as toMutableSet,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  coerceAtMost322komnqp70ag as coerceAtMost,
  joinToString1cxrrlmo0chqs as joinToString,
  Iterable1y3qizuf89iou as Iterable,
  copyOf2ng0t8oizk6it as copyOf_2,
  toString30pk9tzaqopn as toString_0,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  Comparator2b3maoeh98xtg as Comparator,
  reversed3cb5fwpceefdb as reversed,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  contentEqualsaf55p28mnw74 as contentEquals_1,
  contentHashCode2i020q5tbeh2s as contentHashCode_1,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  toRawBits2035dtuolth0v as toRawBits,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  getOrNull1go7ef9ldk0df as getOrNull,
  step18s9qzr5xwxat as step,
  arrayCopytctsywo3h7gj as arrayCopy,
  round2mrvepag8eey0 as round,
  toList383f556t1dixk as toList_0,
} from './kotlin-kotlin-stdlib.mjs';
import {
  umod164hvijxhfi8p as umod,
  ilog2Ceil34a3ub1n8578t as ilog2Ceil,
  isAlmostEquals$default2ib7nwup21mfy as isAlmostEquals$default,
  roundDecimalPlaces1x32iuyd1l8m5 as roundDecimalPlaces,
  appendNice3hizhj9kone09 as appendNice,
  appendGenericArray5krccch8fjd0 as appendGenericArray,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  listIterator247sl90ooi4qv as listIterator,
  DoubleList2honu8rif2roh as DoubleList,
  fastArrayListOf1rdodhrpn0q8y as fastArrayListOf,
  FastArrayListw5fr1wlp4slq as FastArrayList,
  Mixin3lmkm5hum2vdj as Mixin,
} from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import {
  NonRecursiveLock2vf7fkhp857q as NonRecursiveLock,
  Lock5n7hh3dgcidl as Lock,
} from './korlibs-concurrent-root-korlibs-concurrent.mjs';
import {
  Vector2D378fe5rov8fgw as Vector2D,
  IDoubleVectorListoa05cse3he2p as IDoubleVectorList,
  IPointListz7raskb2mrxa as IPointList,
  isNotEmptyrwyeygz7izwg as isNotEmpty,
  isAlmostEquals2qd88bwpjj4z5 as isAlmostEquals,
  containsAll194lepx84fvib as containsAll,
  indexOf3tp8bzbv46hci as indexOf,
  iterator1sm8hwbj0nmg8 as iterator,
  listIteratorrk3szyua4uzm as listIterator_0,
  listIterator3ooh2yjav3kr9 as listIterator_1,
  subList2funs4qwcrhhq as subList,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Companion {}
class IArray2 {}
function inside(x, y) {
  return x >= 0 && y >= 0 && x < this.z2i() && y < this.a2j();
}
function getAt(x, y) {
  return this.h2j(x, y) ? this.ux(indexOr(this, x, y)) : this.ux(0);
}
function asString() {
  var tmp = until(0, this.a2j());
  return joinToString(tmp, '\n', VOID, VOID, VOID, VOID, IArray2$asString$lambda(this));
}
class IntIArray2 {}
function get(x, y) {
  return this.c2j(indexOr(this, x, y));
}
function set(x, y, value) {
  return this.d2j(indexOr(this, x, y), value);
}
function getAt_0(idx) {
  return this.c2j(idx);
}
class IntArray2 {
  constructor(width, height, data) {
    this.w2i_1 = width;
    this.x2i_1 = height;
    this.y2i_1 = data;
    Companion_instance_4.b2j(this.z2i(), this.a2j(), this.y2i_1.length);
  }
  z2i() {
    return this.w2i_1;
  }
  a2j() {
    return this.x2i_1;
  }
  equals(other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof IntArray2) {
      tmp_1 = this.z2i() === other.z2i();
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.a2j() === other.a2j();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentEquals(this.y2i_1, other.y2i_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  c2j(idx) {
    // Inline function 'kotlin.collections.getOrElse' call
    var this_0 = this.y2i_1;
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (0 <= idx ? idx <= (this_0.length - 1 | 0) : false) {
      tmp = this_0[idx];
    } else {
      // Inline function 'korlibs.datastructure.IntArray2.getFast.<anonymous>' call
      tmp = this.y2i_1[0];
    }
    return tmp;
  }
  d2j(idx, value) {
    if (0 <= idx ? idx <= (this.y2i_1.length - 1 | 0) : false) {
      this.y2i_1[idx] = value;
    }
  }
  hashCode() {
    return (this.z2i() + this.a2j() | 0) + contentHashCode(this.y2i_1) | 0;
  }
  a1() {
    return intArrayIterator(this.y2i_1);
  }
  toString() {
    return this.e2j();
  }
}
class Companion_0 {}
class FloatIArray2 {}
function get_0(x, y) {
  return this.c2j(indexOr(this, x, y));
}
function set_0(x, y, value) {
  return this.l2j(indexOr(this, x, y), value);
}
function getAt_1(idx) {
  return this.c2j(idx);
}
class FloatArray2 {
  constructor(width, height, data) {
    this.i2j_1 = width;
    this.j2j_1 = height;
    this.k2j_1 = data;
    Companion_instance_4.b2j(this.z2i(), this.a2j(), this.k2j_1.length);
  }
  z2i() {
    return this.i2j_1;
  }
  a2j() {
    return this.j2j_1;
  }
  equals(other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof FloatArray2) {
      tmp_1 = this.z2i() === other.z2i();
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.a2j() === other.a2j();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentEquals_0(this.k2j_1, other.k2j_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  c2j(idx) {
    // Inline function 'kotlin.collections.getOrElse' call
    var this_0 = this.k2j_1;
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (0 <= idx ? idx <= (this_0.length - 1 | 0) : false) {
      tmp = this_0[idx];
    } else {
      // Inline function 'korlibs.datastructure.FloatArray2.getFast.<anonymous>' call
      tmp = 0.0;
    }
    return tmp;
  }
  l2j(idx, value) {
    if (0 <= idx ? idx <= (this.k2j_1.length - 1 | 0) : false) {
      this.k2j_1[idx] = value;
    }
  }
  hashCode() {
    return (this.z2i() + this.a2j() | 0) + contentHashCode_0(this.k2j_1) | 0;
  }
  a1() {
    return floatArrayIterator(this.k2j_1);
  }
  toString() {
    return this.e2j();
  }
}
class Companion_1 {}
class FloatArrayList {
  static p2j(capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    var $this = createThis(this);
    var tmp = $this;
    var tmp_0 = new Float32Array(capacity);
    tmp.n2j_1 = isFloatArray(tmp_0) ? tmp_0 : THROW_CCE();
    $this.o2j_1 = 0;
    return $this;
  }
  ct(value) {
    ensure(this, value);
    this.o2j_1 = value;
  }
  e1() {
    return this.o2j_1;
  }
  static q2j(other) {
    var $this = this.p2j();
    $this.r2j(other);
    return $this;
  }
  l3() {
    this.o2j_1 = 0;
  }
  s2j(v0, v1, v2, v3) {
    ensure(this, 4);
    var tmp = this.n2j_1;
    var _unary__edvuaz = this.o2j_1;
    this.o2j_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
    var tmp_0 = this.n2j_1;
    var _unary__edvuaz_0 = this.o2j_1;
    this.o2j_1 = _unary__edvuaz_0 + 1 | 0;
    tmp_0[_unary__edvuaz_0] = v1;
    var tmp_1 = this.n2j_1;
    var _unary__edvuaz_1 = this.o2j_1;
    this.o2j_1 = _unary__edvuaz_1 + 1 | 0;
    tmp_1[_unary__edvuaz_1] = v2;
    var tmp_2 = this.n2j_1;
    var _unary__edvuaz_2 = this.o2j_1;
    this.o2j_1 = _unary__edvuaz_2 + 1 | 0;
    tmp_2[_unary__edvuaz_2] = v3;
  }
  t2j(values, offset, length) {
    ensure(this, length);
    var tmp = Memory_instance;
    tmp.u2j(isFloatArray(values) ? values : THROW_CCE(), offset, this.n2j_1, this.e1(), length);
    this.ct(this.e1() + length | 0);
  }
  r2j(values, offset, length, $super) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? values.length : length;
    var tmp;
    if ($super === VOID) {
      this.t2j(values, offset, length);
      tmp = Unit_instance;
    } else {
      tmp = $super.t2j.call(this, values, offset, length);
    }
    return tmp;
  }
  ux(index) {
    return this.n2j_1[index];
  }
  a1() {
    return this.i1(0);
  }
  v2j(element) {
    var inductionVariable = 0;
    var last = this.o2j_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.n2j_1[n] === element)
          return true;
      }
       while (inductionVariable < last);
    return false;
  }
  z2(element) {
    if (!(!(element == null) ? typeof element === 'number' : false))
      return false;
    return this.v2j((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  }
  w2j(elements) {
    var _iterator__ex2g4s = elements.a1();
    while (_iterator__ex2g4s.b1()) {
      var e = _iterator__ex2g4s.c1();
      if (!this.v2j(e))
        return false;
    }
    return true;
  }
  a3(elements) {
    return this.w2j(elements);
  }
  g1() {
    return this.e1() === 0;
  }
  x2j() {
    return copyOf(this.n2j_1, this.o2j_1);
  }
  i1(index) {
    return take(this.n2j_1, this.o2j_1).i1(index);
  }
  hashCode() {
    return contentHashCode_2(this.n2j_1, 0, this.e1());
  }
  equals(other) {
    if (other instanceof FloatArrayList)
      return this.e1() === other.e1() && contentEquals_2(this.n2j_1, other.n2j_1, 0, this.e1());
    if (!(other == null) ? isInterface(other, KtList) : false)
      return equals(other, this);
    return false;
  }
  toString() {
    // Inline function 'kotlin.also' call
    var this_0 = StringBuilder.yb(2 + imul(5, this.e1()) | 0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.FloatArrayList.toString.<anonymous>' call
    this_0.ub(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n === 0)) {
          this_0.tb(', ');
        }
        this_0.ug(this.ux(n));
      }
       while (inductionVariable < last);
    this_0.ub(_Char___init__impl__6a9atx(93));
    return this_0.toString();
  }
}
class Companion_2 {}
class IntArrayList {
  static a2k(capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    var $this = createThis(this);
    var tmp = $this;
    var tmp_0 = new Int32Array(capacity);
    tmp.y2j_1 = isIntArray(tmp_0) ? tmp_0 : THROW_CCE();
    $this.z2j_1 = 0;
    return $this;
  }
  ct(value) {
    this.b2k(value);
    this.z2j_1 = value;
  }
  e1() {
    return this.z2j_1;
  }
  static c2k(other) {
    var $this = this.a2k();
    $this.d2k(other);
    return $this;
  }
  static e2k(other) {
    var $this = this.a2k();
    $this.f2k(other);
    return $this;
  }
  b2k(count) {
    if ((this.z2j_1 + count | 0) > this.y2j_1.length) {
      var tmp = this;
      var tmp_0 = this.y2j_1;
      // Inline function 'kotlin.math.max' call
      var a = this.z2j_1 + count | 0;
      var b = imul(this.y2j_1.length, 3);
      var tmp$ret$0 = Math.max(a, b);
      var tmp_1 = copyOf_0(tmp_0, tmp$ret$0);
      tmp.y2j_1 = isIntArray(tmp_1) ? tmp_1 : THROW_CCE();
    }
  }
  l3() {
    this.z2j_1 = 0;
  }
  g2k(v0) {
    this.b2k(1);
    var tmp = this.y2j_1;
    var _unary__edvuaz = this.z2j_1;
    this.z2j_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
  }
  h2k(v0, v1, v2, v3) {
    this.b2k(4);
    var tmp = this.y2j_1;
    var _unary__edvuaz = this.z2j_1;
    this.z2j_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
    var tmp_0 = this.y2j_1;
    var _unary__edvuaz_0 = this.z2j_1;
    this.z2j_1 = _unary__edvuaz_0 + 1 | 0;
    tmp_0[_unary__edvuaz_0] = v1;
    var tmp_1 = this.y2j_1;
    var _unary__edvuaz_1 = this.z2j_1;
    this.z2j_1 = _unary__edvuaz_1 + 1 | 0;
    tmp_1[_unary__edvuaz_1] = v2;
    var tmp_2 = this.y2j_1;
    var _unary__edvuaz_2 = this.z2j_1;
    this.z2j_1 = _unary__edvuaz_2 + 1 | 0;
    tmp_2[_unary__edvuaz_2] = v3;
  }
  i2k(v0, v1, v2, v3, v4, v5) {
    this.b2k(6);
    var tmp = this.y2j_1;
    var _unary__edvuaz = this.z2j_1;
    this.z2j_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
    var tmp_0 = this.y2j_1;
    var _unary__edvuaz_0 = this.z2j_1;
    this.z2j_1 = _unary__edvuaz_0 + 1 | 0;
    tmp_0[_unary__edvuaz_0] = v1;
    var tmp_1 = this.y2j_1;
    var _unary__edvuaz_1 = this.z2j_1;
    this.z2j_1 = _unary__edvuaz_1 + 1 | 0;
    tmp_1[_unary__edvuaz_1] = v2;
    var tmp_2 = this.y2j_1;
    var _unary__edvuaz_2 = this.z2j_1;
    this.z2j_1 = _unary__edvuaz_2 + 1 | 0;
    tmp_2[_unary__edvuaz_2] = v3;
    var tmp_3 = this.y2j_1;
    var _unary__edvuaz_3 = this.z2j_1;
    this.z2j_1 = _unary__edvuaz_3 + 1 | 0;
    tmp_3[_unary__edvuaz_3] = v4;
    var tmp_4 = this.y2j_1;
    var _unary__edvuaz_4 = this.z2j_1;
    this.z2j_1 = _unary__edvuaz_4 + 1 | 0;
    tmp_4[_unary__edvuaz_4] = v5;
  }
  j2k(value) {
    return this.g2k(value);
  }
  k2k(value) {
    return this.d2k(value);
  }
  l2k(values, offset, length) {
    this.b2k(length);
    var tmp = Memory_instance;
    tmp.m2k(isIntArray(values) ? values : THROW_CCE(), offset, this.y2j_1, this.e1(), length);
    this.ct(this.e1() + length | 0);
  }
  f2k(values, offset, length, $super) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? values.length : length;
    var tmp;
    if ($super === VOID) {
      this.l2k(values, offset, length);
      tmp = Unit_instance;
    } else {
      tmp = $super.l2k.call(this, values, offset, length);
    }
    return tmp;
  }
  d2k(values) {
    return this.l2k(values.y2j_1, 0, values.e1());
  }
  d1(index) {
    return this.y2j_1[index];
  }
  ux(index) {
    return this.y2j_1[index];
  }
  n2k(index, value) {
    if (index >= this.z2j_1) {
      this.b2k(index + 1 | 0);
      this.z2j_1 = index + 1 | 0;
    }
    this.y2j_1[index] = value;
  }
  a1() {
    return this.i1(0);
  }
  gp(element) {
    var inductionVariable = 0;
    var last = this.z2j_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.y2j_1[n] === element)
          return true;
      }
       while (inductionVariable < last);
    return false;
  }
  z2(element) {
    if (!(!(element == null) ? typeof element === 'number' : false))
      return false;
    return this.gp((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  }
  o2k(elements) {
    var _iterator__ex2g4s = elements.a1();
    while (_iterator__ex2g4s.b1()) {
      var e = _iterator__ex2g4s.c1();
      if (!this.gp(e))
        return false;
    }
    return true;
  }
  a3(elements) {
    return this.o2k(elements);
  }
  g1() {
    return this.e1() === 0;
  }
  x27() {
    return !(this.e1() === 0);
  }
  nk() {
    var tmp;
    if (this.g1()) {
      throw IndexOutOfBoundsException.be();
    } else {
      tmp = this.y2j_1[0];
    }
    return tmp;
  }
  p2k() {
    var tmp;
    if (this.g1()) {
      throw IndexOutOfBoundsException.be();
    } else {
      tmp = this.y2j_1[this.z2j_1 - 1 | 0];
    }
    return tmp;
  }
  q2k(index, value) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntArrayList.insertAt.<anonymous>' call
    this.b2k(1);
    if (this.x27()) {
      Memory_instance.m2k(this.y2j_1, index, this.y2j_1, index + 1 | 0, this.z2j_1 - index | 0);
    }
    this.y2j_1[index] = value;
    this.z2j_1 = this.z2j_1 + 1 | 0;
    return this;
  }
  r2k(indexA, indexB) {
    var l = this.ux(indexA);
    var r = this.ux(indexB);
    this.n2k(indexA, r);
    this.n2k(indexB, l);
  }
  p3(index) {
    return this.s2k(index, 1);
  }
  s2k(index, count) {
    if (index < 0 || index >= this.z2j_1 || (index + count | 0) > this.z2j_1)
      throw IndexOutOfBoundsException.be();
    var out = this.y2j_1[index];
    if (count > 0) {
      if (index < (this.z2j_1 - count | 0)) {
        Memory_instance.m2k(this.y2j_1, index + count | 0, this.y2j_1, index, (this.z2j_1 - index | 0) - count | 0);
      }
      this.z2j_1 = this.z2j_1 - count | 0;
    }
    return out;
  }
  t2k() {
    return copyOf_0(this.y2j_1, this.z2j_1);
  }
  i1(index) {
    return take_0(this.y2j_1, this.z2j_1).i1(index);
  }
  hashCode() {
    return contentHashCode_3(this.y2j_1, 0, this.e1());
  }
  equals(other) {
    if (other instanceof IntArrayList)
      return this.e1() === other.e1() && contentEquals_3(this.y2j_1, other.y2j_1, 0, this.e1());
    if (!(other == null) ? isInterface(other, KtList) : false)
      return equals(other, this);
    return false;
  }
  toString() {
    // Inline function 'kotlin.also' call
    var this_0 = StringBuilder.yb(2 + imul(5, this.e1()) | 0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntArrayList.toString.<anonymous>' call
    this_0.ub(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n === 0)) {
          this_0.tb(', ');
        }
        this_0.sg(this.ux(n));
      }
       while (inductionVariable < last);
    this_0.ub(_Char___init__impl__6a9atx(93));
    return this_0.toString();
  }
}
class Companion_3 {}
class DoubleArrayList {
  static w2k(capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    var $this = createThis(this);
    var tmp = $this;
    var tmp_0 = new Float64Array(capacity);
    tmp.u2k_1 = isDoubleArray(tmp_0) ? tmp_0 : THROW_CCE();
    $this.v2k_1 = 0;
    return $this;
  }
  ct(value) {
    ensure_0(this, value);
    this.v2k_1 = value;
  }
  e1() {
    return this.v2k_1;
  }
  static x2k(other) {
    var $this = this.w2k();
    $this.y2k(other);
    return $this;
  }
  static z2k(other) {
    var $this = this.w2k();
    $this.a2l(other);
    return $this;
  }
  l3() {
    this.v2k_1 = 0;
  }
  sz(v0) {
    ensure_0(this, 1);
    var tmp = this.u2k_1;
    var _unary__edvuaz = this.v2k_1;
    this.v2k_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
  }
  b2l(v0, v1) {
    ensure_0(this, 2);
    var tmp = this.u2k_1;
    var _unary__edvuaz = this.v2k_1;
    this.v2k_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
    var tmp_0 = this.u2k_1;
    var _unary__edvuaz_0 = this.v2k_1;
    this.v2k_1 = _unary__edvuaz_0 + 1 | 0;
    tmp_0[_unary__edvuaz_0] = v1;
  }
  c2l(v0, v1, v2, v3) {
    ensure_0(this, 4);
    var tmp = this.u2k_1;
    var _unary__edvuaz = this.v2k_1;
    this.v2k_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
    var tmp_0 = this.u2k_1;
    var _unary__edvuaz_0 = this.v2k_1;
    this.v2k_1 = _unary__edvuaz_0 + 1 | 0;
    tmp_0[_unary__edvuaz_0] = v1;
    var tmp_1 = this.u2k_1;
    var _unary__edvuaz_1 = this.v2k_1;
    this.v2k_1 = _unary__edvuaz_1 + 1 | 0;
    tmp_1[_unary__edvuaz_1] = v2;
    var tmp_2 = this.u2k_1;
    var _unary__edvuaz_2 = this.v2k_1;
    this.v2k_1 = _unary__edvuaz_2 + 1 | 0;
    tmp_2[_unary__edvuaz_2] = v3;
  }
  d2l(v0, v1, v2, v3, v4, v5) {
    ensure_0(this, 6);
    var tmp = this.u2k_1;
    var _unary__edvuaz = this.v2k_1;
    this.v2k_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
    var tmp_0 = this.u2k_1;
    var _unary__edvuaz_0 = this.v2k_1;
    this.v2k_1 = _unary__edvuaz_0 + 1 | 0;
    tmp_0[_unary__edvuaz_0] = v1;
    var tmp_1 = this.u2k_1;
    var _unary__edvuaz_1 = this.v2k_1;
    this.v2k_1 = _unary__edvuaz_1 + 1 | 0;
    tmp_1[_unary__edvuaz_1] = v2;
    var tmp_2 = this.u2k_1;
    var _unary__edvuaz_2 = this.v2k_1;
    this.v2k_1 = _unary__edvuaz_2 + 1 | 0;
    tmp_2[_unary__edvuaz_2] = v3;
    var tmp_3 = this.u2k_1;
    var _unary__edvuaz_3 = this.v2k_1;
    this.v2k_1 = _unary__edvuaz_3 + 1 | 0;
    tmp_3[_unary__edvuaz_3] = v4;
    var tmp_4 = this.u2k_1;
    var _unary__edvuaz_4 = this.v2k_1;
    this.v2k_1 = _unary__edvuaz_4 + 1 | 0;
    tmp_4[_unary__edvuaz_4] = v5;
  }
  e2l(value) {
    return this.sz(value);
  }
  f2l(value) {
    return this.y2k(value);
  }
  g2l(values, offset, length) {
    ensure_0(this, length);
    var tmp = Memory_instance;
    tmp.h2l(isDoubleArray(values) ? values : THROW_CCE(), offset, this.u2k_1, this.e1(), length);
    this.ct(this.e1() + length | 0);
  }
  a2l(values, offset, length, $super) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? values.length : length;
    var tmp;
    if ($super === VOID) {
      this.g2l(values, offset, length);
      tmp = Unit_instance;
    } else {
      tmp = $super.g2l.call(this, values, offset, length);
    }
    return tmp;
  }
  y2k(values) {
    return this.g2l(values.u2k_1, 0, values.e1());
  }
  d1(index) {
    return this.u2k_1[index];
  }
  ux(index) {
    return this.u2k_1[index];
  }
  i2l(index, value) {
    if (index >= this.v2k_1) {
      ensure_0(this, index + 1 | 0);
      this.v2k_1 = index + 1 | 0;
    }
    this.u2k_1[index] = value;
  }
  a1() {
    return this.i1(0);
  }
  xx(element) {
    var inductionVariable = 0;
    var last = this.v2k_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.u2k_1[n] === element)
          return true;
      }
       while (inductionVariable < last);
    return false;
  }
  z2(element) {
    if (!(!(element == null) ? typeof element === 'number' : false))
      return false;
    return this.xx((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  }
  yx(elements) {
    var _iterator__ex2g4s = elements.a1();
    while (_iterator__ex2g4s.b1()) {
      var e = _iterator__ex2g4s.c1();
      if (!this.xx(e))
        return false;
    }
    return true;
  }
  a3(elements) {
    return this.yx(elements);
  }
  g1() {
    return this.e1() === 0;
  }
  r2k(indexA, indexB) {
    var l = this.ux(indexA);
    var r = this.ux(indexB);
    this.i2l(indexA, r);
    this.i2l(indexB, l);
  }
  p3(index) {
    return this.s2k(index, 1);
  }
  s2k(index, count) {
    if (index < 0 || index >= this.v2k_1 || (index + count | 0) > this.v2k_1)
      throw IndexOutOfBoundsException.be();
    var out = this.u2k_1[index];
    if (count > 0) {
      if (index < (this.v2k_1 - count | 0)) {
        Memory_instance.h2l(this.u2k_1, index + count | 0, this.u2k_1, index, (this.v2k_1 - index | 0) - count | 0);
      }
      this.v2k_1 = this.v2k_1 - count | 0;
    }
    return out;
  }
  vx() {
    return copyOf_1(this.u2k_1, this.v2k_1);
  }
  i1(index) {
    return take_1(this.u2k_1, this.v2k_1).i1(index);
  }
  c3(fromIndex, toIndex) {
    // Inline function 'kotlin.collections.asList' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.u2k_1;
    return asList(tmp$ret$1).c3(fromIndex, toIndex);
  }
  wx() {
    return DoubleArrayList.x2k(this);
  }
  hashCode() {
    return contentHashCode_4(this.u2k_1, 0, this.e1());
  }
  equals(other) {
    if (other instanceof DoubleArrayList)
      return this.e1() === other.e1() && contentEquals_4(this.u2k_1, other.u2k_1, 0, this.e1());
    if (!(other == null) ? isInterface(other, KtList) : false)
      return equals(other, this);
    return false;
  }
  toString() {
    // Inline function 'kotlin.also' call
    var this_0 = StringBuilder.yb(2 + imul(5, this.e1()) | 0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.DoubleArrayList.toString.<anonymous>' call
    this_0.ub(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n === 0)) {
          this_0.tb(', ');
        }
        this_0.vg(this.ux(n));
      }
       while (inductionVariable < last);
    this_0.ub(_Char___init__impl__6a9atx(93));
    return this_0.toString();
  }
}
class SortOps {
  o2l(subject, indexL, indexR) {
    var inductionVariable = indexR;
    var last = indexL + 1 | 0;
    if (last <= inductionVariable)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        this.n2l(subject, n - 1 | 0, n);
      }
       while (!(n === last));
  }
  j2l(subject, indexL, indexR) {
    var count = (indexR - indexL | 0) + 1 | 0;
    var inductionVariable = 0;
    var last = count / 2 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.n2l(subject, indexL + n | 0, indexR - n | 0);
      }
       while (inductionVariable < last);
  }
}
class DoubleArrayListSortOps extends SortOps {
  constructor() {
    DoubleArrayListSortOps_instance = null;
    super();
    DoubleArrayListSortOps_instance = this;
  }
  k2l(subject, l, r) {
    return compareTo(subject.ux(l), subject.ux(r));
  }
  l2l(subject, l, r) {
    return this.k2l(subject instanceof DoubleArrayList ? subject : THROW_CCE(), l, r);
  }
  m2l(subject, indexL, indexR) {
    var l = subject.ux(indexL);
    var r = subject.ux(indexR);
    subject.i2l(indexR, l);
    subject.i2l(indexL, r);
  }
  n2l(subject, indexL, indexR) {
    return this.m2l(subject instanceof DoubleArrayList ? subject : THROW_CCE(), indexL, indexR);
  }
}
class TGenDeque$iterator$1 {
  constructor($that, this$0) {
    this.u2l_1 = $that;
    this.v2l_1 = this$0;
    this.t2l_1 = 0;
  }
  c1() {
    var _unary__edvuaz = this.t2l_1;
    this.t2l_1 = _unary__edvuaz + 1 | 0;
    return this.u2l_1.d1(_unary__edvuaz);
  }
  b1() {
    return this.t2l_1 < this.v2l_1.e1();
  }
  j6() {
    this.t2l_1 = this.t2l_1 - 1 | 0;
    this.v2l_1.p3(this.t2l_1);
  }
}
class TGenDeque {
  static w2l(initialCapacity) {
    var $this = createThis(this);
    $this.p2l_1 = 0;
    $this.q2l_1 = 0;
    var tmp = $this;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_0 = fillArrayVal(Array(initialCapacity), null);
    tmp.r2l_1 = isArray(tmp_0) ? tmp_0 : THROW_CCE();
    return $this;
  }
  static x2l() {
    return this.w2l(16);
  }
  e1() {
    return this.q2l_1;
  }
  g1() {
    return this.e1() === 0;
  }
  y2l(item) {
    resizeIfRequiredFor(this, 1);
    _addLast(this, item);
  }
  z2l(item) {
    resizeIfRequiredFor(this, 1);
    this.p2l_1 = umod(this.p2l_1 - 1 | 0, _get_capacity__a9k9f3(this));
    this.q2l_1 = this.q2l_1 + 1 | 0;
    this.r2l_1[this.p2l_1] = item;
  }
  a2m(list) {
    // Inline function 'korlibs.datastructure.TGenDeque._addAll' call
    var count = list.e1();
    resizeIfRequiredFor(this, count);
    var base = this.p2l_1 + this.q2l_1 | 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this.r2l_1;
        var tmp_0 = (base + n | 0) % _get_capacity__a9k9f3(this) | 0;
        // Inline function 'korlibs.datastructure.TGenDeque.addAll.<anonymous>' call
        tmp[tmp_0] = list.d1(n);
      }
       while (inductionVariable < count);
    this.q2l_1 = this.q2l_1 + count | 0;
    return true;
  }
  b2m(elements) {
    return this.a2m(toList(elements));
  }
  f1(elements) {
    return this.b2m(elements);
  }
  c2m(items) {
    // Inline function 'korlibs.datastructure.TGenDeque._addAllFirst' call
    var count = items.e1();
    resizeIfRequiredFor(this, count);
    this.p2l_1 = umod(this.p2l_1 - count | 0, _get_capacity__a9k9f3(this));
    this.q2l_1 = this.q2l_1 + count | 0;
    var pos = this.p2l_1;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this.r2l_1;
        var _unary__edvuaz = pos;
        pos = _unary__edvuaz + 1 | 0;
        var tmp_0 = umod(_unary__edvuaz, _get_capacity__a9k9f3(this));
        // Inline function 'korlibs.datastructure.TGenDeque.addAllFirst.<anonymous>' call
        tmp[tmp_0] = items.d1(n);
      }
       while (inductionVariable < count);
    return true;
  }
  qk() {
    if (this.q2l_1 <= 0)
      throw IndexOutOfBoundsException.be();
    var out = this.d2m();
    nullify(this, this.p2l_1);
    this.p2l_1 = (this.p2l_1 + 1 | 0) % _get_capacity__a9k9f3(this) | 0;
    this.q2l_1 = this.q2l_1 - 1 | 0;
    return out;
  }
  sk() {
    if (this.q2l_1 <= 0)
      throw IndexOutOfBoundsException.be();
    var out = this.e2m();
    nullify(this, internalIndex(this, this.e1() - 1 | 0));
    this.q2l_1 = this.q2l_1 - 1 | 0;
    return out;
  }
  p3(index) {
    if (index < 0 || index >= this.e1())
      throw IndexOutOfBoundsException.be();
    if (index === 0)
      return this.qk();
    if (index === (this.e1() - 1 | 0))
      return this.sk();
    var old = this.d1(index);
    if (index < (this.e1() / 2 | 0)) {
      var inductionVariable = index;
      if (1 <= inductionVariable)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          this.f2m(n, this.d1(n - 1 | 0));
        }
         while (1 <= inductionVariable);
      this.p2l_1 = umod(this.p2l_1 + 1 | 0, _get_capacity__a9k9f3(this));
    } else {
      var inductionVariable_0 = index;
      var last = this.e1() - 1 | 0;
      if (inductionVariable_0 < last)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this.f2m(n_0, this.d1(n_0 + 1 | 0));
        }
         while (inductionVariable_0 < last);
    }
    this.q2l_1 = this.q2l_1 - 1 | 0;
    return old;
  }
  g2m(element) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.TGenDeque.add.<anonymous>' call
    this.y2l(element);
    return true;
  }
  h(element) {
    return this.g2m((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  l3() {
    this.q2l_1 = 0;
  }
  h2m(element) {
    var index = this.i2m(element);
    if (index >= 0) {
      this.p3(index);
    }
    return index >= 0;
  }
  m3(element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.h2m((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  j2m(elements) {
    return _removeRetainAll(this, elements, false);
  }
  d2m() {
    return this.r2l_1[this.p2l_1];
  }
  e2m() {
    return this.r2l_1[internalIndex(this, this.e1() - 1 | 0)];
  }
  f2m(index, value) {
    this.r2l_1[internalIndex(this, index)] = value;
  }
  d1(index) {
    return this.r2l_1[internalIndex(this, index)];
  }
  k2m(index) {
    return (0 <= index ? index <= (this.e1() - 1 | 0) : false) ? this.d1(index) : null;
  }
  l2m(element) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var this_0 = until(0, this.e1());
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.g1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var inductionVariable = this_0.d2_1;
      var last = this_0.e2_1;
      if (inductionVariable <= last)
        do {
          var element_0 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.datastructure.TGenDeque.contains.<anonymous>' call
          var it = element_0;
          if (equals(this.d1(it), element)) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
        }
         while (!(element_0 === last));
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  }
  z2(element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.l2m((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  i2m(element) {
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals(this.d1(n), element))
          return n;
      }
       while (inductionVariable < last);
    return -1;
  }
  m2m(elements) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(elements, 10));
    var tmp0_iterator = elements.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.datastructure.TGenDeque.containsAll.<anonymous>' call
      var tmp$ret$0 = to(item, 0);
      destination.h(tmp$ret$0);
    }
    var emap = toLinkedMap(destination);
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var it = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var e = this.d1(it);
        // Inline function 'kotlin.collections.contains' call
        // Inline function 'kotlin.collections.containsKey' call
        if ((isInterface(emap, KtMap) ? emap : THROW_CCE()).d3(e)) {
          // Inline function 'kotlin.collections.set' call
          emap.i3(e, 1);
        }
      }
       while (inductionVariable < last);
    var tmp$ret$5;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var this_0 = emap.h3();
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.g1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$5 = true;
        break $l$block_0;
      }
      var tmp0_iterator_0 = this_0.a1();
      while (tmp0_iterator_0.b1()) {
        var element = tmp0_iterator_0.c1();
        // Inline function 'korlibs.datastructure.TGenDeque.containsAll.<anonymous>' call
        if (!(element === 1)) {
          tmp$ret$5 = false;
          break $l$block_0;
        }
      }
      tmp$ret$5 = true;
    }
    return tmp$ret$5;
  }
  a3(elements) {
    return this.m2m(elements);
  }
  a1() {
    var that = this;
    return new TGenDeque$iterator$1(that, this);
  }
  hashCode() {
    // Inline function 'korlibs.datastructure.internal.contentHashCode' call
    var size = this.e1();
    var result = 1;
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = imul(31, result);
        // Inline function 'kotlin.hashCode' call
        // Inline function 'korlibs.datastructure.TGenDeque.hashCode.<anonymous>' call
        var tmp0_safe_receiver = this.d1(n);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
      }
       while (inductionVariable < size);
    return result;
  }
  equals(other) {
    if (!(other instanceof TGenDeque))
      return false;
    if (!(other.e1() === this.e1()))
      return false;
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!equals(this.d1(n), other.d1(n)))
          return false;
      }
       while (inductionVariable < last);
    return true;
  }
  toString() {
    var sb = StringBuilder.f();
    sb.ub(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        sb.sb(this.d1(n));
        if (!(n === (this.e1() - 1 | 0))) {
          sb.tb(', ');
        }
      }
       while (inductionVariable < last);
    sb.ub(_Char___init__impl__6a9atx(93));
    return sb.toString();
  }
}
class IntDeque$iterator$1 {
  constructor($that, this$0) {
    this.r2m_1 = $that;
    this.s2m_1 = this$0;
    this.q2m_1 = 0;
  }
  c1() {
    var _unary__edvuaz = this.q2m_1;
    this.q2m_1 = _unary__edvuaz + 1 | 0;
    return this.r2m_1.d1(_unary__edvuaz);
  }
  b1() {
    return this.q2m_1 < this.s2m_1.e1();
  }
  j6() {
    this.q2m_1 = this.q2m_1 - 1 | 0;
    this.s2m_1.p3(this.q2m_1);
  }
}
class IntDeque {
  static t2m(initialCapacity) {
    var $this = createThis(this);
    $this.n2m_1 = 0;
    $this.o2m_1 = 0;
    var tmp = $this;
    var tmp_0 = new Int32Array(initialCapacity);
    tmp.p2m_1 = isIntArray(tmp_0) ? tmp_0 : THROW_CCE();
    return $this;
  }
  static u2m() {
    return this.t2m(16);
  }
  e1() {
    return this.o2m_1;
  }
  g1() {
    return this.e1() === 0;
  }
  v2m(item) {
    resizeIfRequiredFor_0(this, 1);
    _addLast_0(this, item);
  }
  w2m(list) {
    // Inline function 'korlibs.datastructure.IntDeque._addAll' call
    var count = list.e1();
    resizeIfRequiredFor_0(this, count);
    var base = this.n2m_1 + this.o2m_1 | 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this.p2m_1;
        var tmp_0 = (base + n | 0) % _get_capacity__a9k9f3_0(this) | 0;
        // Inline function 'korlibs.datastructure.IntDeque.addAll.<anonymous>' call
        tmp[tmp_0] = list.d1(n);
      }
       while (inductionVariable < count);
    this.o2m_1 = this.o2m_1 + count | 0;
    return true;
  }
  x2m(elements) {
    return this.w2m(toList(elements));
  }
  f1(elements) {
    return this.x2m(elements);
  }
  qk() {
    if (this.o2m_1 <= 0)
      throw IndexOutOfBoundsException.be();
    var out = this.d2m();
    nullify_0(this, this.n2m_1);
    this.n2m_1 = (this.n2m_1 + 1 | 0) % _get_capacity__a9k9f3_0(this) | 0;
    this.o2m_1 = this.o2m_1 - 1 | 0;
    return out;
  }
  sk() {
    if (this.o2m_1 <= 0)
      throw IndexOutOfBoundsException.be();
    var out = this.e2m();
    nullify_0(this, internalIndex_0(this, this.e1() - 1 | 0));
    this.o2m_1 = this.o2m_1 - 1 | 0;
    return out;
  }
  p3(index) {
    if (index < 0 || index >= this.e1())
      throw IndexOutOfBoundsException.be();
    if (index === 0)
      return this.qk();
    if (index === (this.e1() - 1 | 0))
      return this.sk();
    var old = this.d1(index);
    if (index < (this.e1() / 2 | 0)) {
      var inductionVariable = index;
      if (1 <= inductionVariable)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          this.n2k(n, this.d1(n - 1 | 0));
        }
         while (1 <= inductionVariable);
      this.n2m_1 = umod(this.n2m_1 + 1 | 0, _get_capacity__a9k9f3_0(this));
    } else {
      var inductionVariable_0 = index;
      var last = this.e1() - 1 | 0;
      if (inductionVariable_0 < last)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this.n2k(n_0, this.d1(n_0 + 1 | 0));
        }
         while (inductionVariable_0 < last);
    }
    this.o2m_1 = this.o2m_1 - 1 | 0;
    return old;
  }
  y2m(element) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntDeque.add.<anonymous>' call
    this.v2m(element);
    return true;
  }
  h(element) {
    return this.y2m((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  }
  z2m(element) {
    var index = this.a2n(element);
    if (index >= 0) {
      this.p3(index);
    }
    return index >= 0;
  }
  m3(element) {
    if (!(!(element == null) ? typeof element === 'number' : false))
      return false;
    return this.z2m((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  }
  d2m() {
    return this.p2m_1[this.n2m_1];
  }
  e2m() {
    return this.p2m_1[internalIndex_0(this, this.e1() - 1 | 0)];
  }
  n2k(index, value) {
    this.p2m_1[internalIndex_0(this, index)] = value;
  }
  d1(index) {
    return this.p2m_1[internalIndex_0(this, index)];
  }
  gp(element) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var this_0 = until(0, this.e1());
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.g1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var inductionVariable = this_0.d2_1;
      var last = this_0.e2_1;
      if (inductionVariable <= last)
        do {
          var element_0 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.datastructure.IntDeque.contains.<anonymous>' call
          var it = element_0;
          if (this.d1(it) === element) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
        }
         while (!(element_0 === last));
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  }
  z2(element) {
    if (!(!(element == null) ? typeof element === 'number' : false))
      return false;
    return this.gp((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  }
  a2n(element) {
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.d1(n) === element)
          return n;
      }
       while (inductionVariable < last);
    return -1;
  }
  o2k(elements) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(elements, 10));
    var tmp0_iterator = elements.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.datastructure.IntDeque.containsAll.<anonymous>' call
      var tmp$ret$0 = to(item, 0);
      destination.h(tmp$ret$0);
    }
    var emap = toLinkedMap(destination);
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var it = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var e = this.d1(it);
        // Inline function 'kotlin.collections.contains' call
        // Inline function 'kotlin.collections.containsKey' call
        if ((isInterface(emap, KtMap) ? emap : THROW_CCE()).d3(e)) {
          // Inline function 'kotlin.collections.set' call
          emap.i3(e, 1);
        }
      }
       while (inductionVariable < last);
    var tmp$ret$5;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var this_0 = emap.h3();
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.g1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$5 = true;
        break $l$block_0;
      }
      var tmp0_iterator_0 = this_0.a1();
      while (tmp0_iterator_0.b1()) {
        var element = tmp0_iterator_0.c1();
        // Inline function 'korlibs.datastructure.IntDeque.containsAll.<anonymous>' call
        if (!(element === 1)) {
          tmp$ret$5 = false;
          break $l$block_0;
        }
      }
      tmp$ret$5 = true;
    }
    return tmp$ret$5;
  }
  a3(elements) {
    return this.o2k(elements);
  }
  a1() {
    var that = this;
    return new IntDeque$iterator$1(that, this);
  }
  hashCode() {
    // Inline function 'korlibs.datastructure.internal.contentHashCode' call
    var size = this.e1();
    var result = 1;
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = imul(31, result);
        // Inline function 'kotlin.hashCode' call
        // Inline function 'korlibs.datastructure.IntDeque.hashCode.<anonymous>' call
        var tmp0_safe_receiver = this.d1(n);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
      }
       while (inductionVariable < size);
    return result;
  }
  equals(other) {
    if (!(other instanceof IntDeque))
      return false;
    if (!(other.e1() === this.e1()))
      return false;
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(this.d1(n) === other.d1(n)))
          return false;
      }
       while (inductionVariable < last);
    return true;
  }
  toString() {
    var sb = StringBuilder.f();
    sb.ub(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        sb.sg(this.d1(n));
        if (!(n === (this.e1() - 1 | 0))) {
          sb.tb(', ');
        }
      }
       while (inductionVariable < last);
    sb.ub(_Char___init__impl__6a9atx(93));
    return sb.toString();
  }
}
class FastSmallSet extends AbstractMutableSet {
  static f2n() {
    var $this = this.u7();
    $this.b2n_1 = LinkedHashSet.j1();
    $this.c2n_1 = null;
    $this.d2n_1 = null;
    $this.e2n_1 = null;
    return $this;
  }
  e1() {
    return this.b2n_1.e1();
  }
  a1() {
    return this.b2n_1.a1();
  }
  g2n(element) {
    if (this.al(element))
      return false;
    this.b2n_1.h(element);
    return true;
  }
  h(element) {
    return this.g2n((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  h2n(element) {
    this.c2n_1 = null;
    this.d2n_1 = null;
    this.e2n_1 = null;
    this.b2n_1.m3(element);
    return true;
  }
  m3(element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.h2n((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  al(element) {
    if (element === this.c2n_1 || element === this.d2n_1 || element === this.c2n_1)
      return true;
    var result = this.b2n_1.z2(element);
    if (result) {
      this.d2n_1 = this.c2n_1;
      this.e2n_1 = this.d2n_1;
      this.c2n_1 = element;
    }
    return result;
  }
  z2(element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.al((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  l3() {
    this.b2n_1.l3();
    this.c2n_1 = null;
    this.d2n_1 = null;
    this.e2n_1 = null;
  }
}
class GenericSubList {
  constructor(base, start, end) {
    this.i2n_1 = base;
    this.j2n_1 = start;
    this.k2n_1 = end;
    var containsUpper = this.i2n_1.e1();
    var containsArg = this.j2n_1;
    if (!(0 <= containsArg ? containsArg <= containsUpper : false))
      throw IndexOutOfBoundsException.q1('' + this.j2n_1);
    var containsUpper_0 = this.i2n_1.e1();
    var containsArg_0 = this.k2n_1;
    if (!(0 <= containsArg_0 ? containsArg_0 <= containsUpper_0 : false))
      throw IndexOutOfBoundsException.q1('' + this.k2n_1);
  }
  e1() {
    return this.k2n_1 - this.j2n_1 | 0;
  }
  al(element) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var this_0 = until(0, this.e1());
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.g1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var inductionVariable = this_0.d2_1;
      var last = this_0.e2_1;
      if (inductionVariable <= last)
        do {
          var element_0 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.datastructure.GenericSubList.contains.<anonymous>' call
          var it = element_0;
          if (equals(this.d1(it), element)) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
        }
         while (!(element_0 === last));
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  }
  z2(element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.al((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  bl(elements) {
    var elementsSet = toMutableSet(elements);
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.minusAssign' call
        var element = this.d1(n);
        elementsSet.m3(element);
      }
       while (inductionVariable < last);
    return elementsSet.g1();
  }
  a3(elements) {
    return this.bl(elements);
  }
  d1(index) {
    return this.i2n_1.d1(translateIndex(index, this));
  }
  l2n(element) {
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals(this.d1(n), element))
          return n;
      }
       while (inductionVariable < last);
    return -1;
  }
  l1(element) {
    if (!(element == null ? true : !(element == null)))
      return -1;
    return this.l2n((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  g1() {
    return this.e1() === 0;
  }
  a1() {
    return new GenericListIterator(this);
  }
  b3() {
    return new GenericListIterator(this);
  }
  i1(index) {
    return new GenericListIterator(this, index);
  }
  c3(fromIndex, toIndex) {
    return new GenericSubList(this, fromIndex, toIndex);
  }
  toString() {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this.e1());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.d2_1;
    var last = this_0.e2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.datastructure.GenericSubList.toString.<anonymous>' call
        var it = item;
        var tmp$ret$0 = this.d1(it);
        destination.h(tmp$ret$0);
      }
       while (!(item === last));
    return toString(destination);
  }
  equals(other) {
    var tmp;
    if (other instanceof GenericSubList) {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'korlibs.datastructure.internal.equaler' call
        var count = this.e1();
        var inductionVariable = 0;
        if (inductionVariable < count)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.datastructure.GenericSubList.equals.<anonymous>' call
            if (!equals(this.d1(n), other.d1(n))) {
              tmp$ret$1 = false;
              break $l$block;
            }
          }
           while (inductionVariable < count);
        tmp$ret$1 = true;
      }
      tmp = tmp$ret$1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.datastructure.internal.hashCoder' call
    var count = this.e1();
    var out = 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out = imul(out, 7);
        var tmp = out;
        // Inline function 'korlibs.datastructure.GenericSubList.hashCode.<anonymous>' call
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver = this.d1(n);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        out = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
      }
       while (inductionVariable < count);
    return out;
  }
}
class GenericListIterator {
  constructor(list, iindex) {
    iindex = iindex === VOID ? 0 : iindex;
    this.m2n_1 = list;
    this.n2n_1 = iindex;
    var containsUpper = this.m2n_1.e1();
    var containsArg = this.n2n_1;
    if (!(0 <= containsArg ? containsArg < containsUpper : false))
      throw IndexOutOfBoundsException.q1('' + this.n2n_1);
    this.o2n_1 = this.n2n_1;
  }
  b1() {
    return this.o2n_1 < this.m2n_1.e1();
  }
  c1() {
    if (!this.b1())
      throw NoSuchElementException.n6();
    var _unary__edvuaz = this.o2n_1;
    this.o2n_1 = _unary__edvuaz + 1 | 0;
    return this.m2n_1.d1(_unary__edvuaz);
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof GenericListIterator) {
      tmp_0 = equals(this.m2n_1, other.m2n_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.o2n_1 === other.o2n_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.m2n_1) + this.o2n_1 | 0;
  }
}
class HistoryStack {
  constructor(maxLength, initialCapacity) {
    maxLength = maxLength === VOID ? 2147483637 : maxLength;
    initialCapacity = initialCapacity === VOID ? 7 : initialCapacity;
    this.p2n_1 = maxLength;
    this.q2n_1 = TGenDeque.w2l(initialCapacity);
    this.r2n_1 = 0;
  }
  s2n(value) {
    $l$loop: while (true) {
      var tmp;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!this.q2n_1.g1()) {
        tmp = this.q2n_1.e1() > this.r2n_1;
      } else {
        tmp = false;
      }
      if (!tmp) {
        break $l$loop;
      }
      this.q2n_1.sk();
    }
    this.q2n_1.g2m(value);
    this.r2n_1 = this.q2n_1.e1();
    $l$loop_0: while (true) {
      var tmp_0;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!this.q2n_1.g1()) {
        tmp_0 = this.q2n_1.e1() > this.p2n_1;
      } else {
        tmp_0 = false;
      }
      if (!tmp_0) {
        break $l$loop_0;
      }
      this.q2n_1.qk();
      this.r2n_1 = this.r2n_1 - 1 | 0;
    }
  }
  t2n() {
    this.r2n_1 = coerceAtLeast(this.r2n_1 - 1 | 0, 0);
    return this.q2n_1.k2m(this.r2n_1 - 1 | 0);
  }
  u2n() {
    // Inline function 'kotlin.also' call
    var this_0 = this.q2n_1.k2m(this.r2n_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.HistoryStack.redo.<anonymous>' call
    this.r2n_1 = coerceAtMost(this.r2n_1 + 1 | 0, this.q2n_1.e1() + 1 | 0);
    return this_0;
  }
}
class Companion_4 {
  b2j(width, height, arraySize) {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(arraySize >= imul(width, height))) {
      // Inline function 'korlibs.datastructure.Companion.checkArraySize.<anonymous>' call
      var message = 'backing array of size=' + arraySize + ', has less elements than ' + width + ' * ' + height;
      throw IllegalStateException.z4(toString(message));
    }
  }
}
class Companion_5 {
  constructor() {
    this.l2o_1 = 2147483646;
    this.m2o_1 = 2147483647;
    this.n2o_1 = 0;
  }
}
class Entry {
  constructor(key, value) {
    this.r2o_1 = key;
    this.s2o_1 = value;
  }
  toString() {
    return 'Entry(key=' + this.r2o_1 + ', value=' + toString_0(this.s2o_1) + ')';
  }
  hashCode() {
    var result = this.r2o_1;
    result = imul(result, 31) + (this.s2o_1 == null ? 0 : hashCode(this.s2o_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry))
      return false;
    var tmp0_other_with_cast = other instanceof Entry ? other : THROW_CCE();
    if (!(this.r2o_1 === tmp0_other_with_cast.r2o_1))
      return false;
    if (!equals(this.s2o_1, tmp0_other_with_cast.s2o_1))
      return false;
    return true;
  }
}
class Iterator {
  constructor(map) {
    this.v2n_1 = map;
    this.w2n_1 = this.v2n_1.b2o_1 ? 2147483647 : nextNonEmptyIndex(this, this.v2n_1.f2o_1, 0);
    this.x2n_1 = new Entry(0, null);
  }
  b1() {
    return !(this.w2n_1 === 2147483646);
  }
  j2o() {
    // Inline function 'kotlin.apply' call
    var this_0 = currentKey(this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.Iterator.nextKey.<anonymous>' call
    next(this);
    return this_0;
  }
  k2o() {
    // Inline function 'kotlin.apply' call
    var this_0 = currentValue(this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.Iterator.nextValue.<anonymous>' call
    next(this);
    return this_0;
  }
}
class _no_name_provided__qut3iv {
  constructor(this$0) {
    this.t2o_1 = this$0;
  }
  a1() {
    // Inline function 'korlibs.datastructure.IntMap.<get-keys>.<anonymous>' call
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntMap.<get-keys>.<anonymous>.<anonymous>' call
    var it = new Iterator(this.t2o_1);
    var tmp = IntMap$_get_keys_$o$iterator$lambda_bn8atq(it);
    return Iterator_0(tmp, IntMap$_get_keys_$o$iterator$lambda_bn8atq_0(it));
  }
}
class _no_name_provided__qut3iv_0 {
  constructor(this$0) {
    this.u2o_1 = this$0;
  }
  a1() {
    // Inline function 'korlibs.datastructure.IntMap.<get-values>.<anonymous>' call
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntMap.<get-values>.<anonymous>.<anonymous>' call
    var it = new Iterator(this.u2o_1);
    var tmp = IntMap$_get_values_$o$iterator$lambda_ggo058(it);
    return Iterator_0(tmp, IntMap$_get_values_$o$iterator$lambda_ggo058_0(it));
  }
}
class IntMap {
  static o2o(nbits, loadFactor, dummy) {
    dummy = dummy === VOID ? false : dummy;
    var $this = createThis(this);
    $this.y2n_1 = nbits;
    $this.z2n_1 = loadFactor;
    $this.a2o_1 = 1 << $this.y2n_1;
    $this.b2o_1 = false;
    $this.c2o_1 = null;
    $this.d2o_1 = $this.a2o_1 - 1 | 0;
    $this.e2o_1 = 1 + imul($this.y2n_1, $this.y2n_1) | 0;
    $this.f2o_1 = new Int32Array($this.q2o());
    var tmp = $this;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = $this.q2o();
    var tmp_0 = fillArrayVal(Array(size), null);
    tmp.g2o_1 = isArray(tmp_0) ? tmp_0 : THROW_CCE();
    $this.h2o_1 = numberToInt($this.a2o_1 * $this.z2n_1);
    $this.i2o_1 = 0;
    return $this;
  }
  static v2o(initialCapacity, loadFactor) {
    initialCapacity = initialCapacity === VOID ? 16 : initialCapacity;
    loadFactor = loadFactor === VOID ? 0.75 : loadFactor;
    // Inline function 'kotlin.math.max' call
    var b = ilog2Ceil(initialCapacity);
    var tmp$ret$0 = Math.max(4, b);
    return this.o2o(tmp$ret$0, loadFactor, true);
  }
  q2o() {
    return this.a2o_1 + this.e2o_1 | 0;
  }
  d1(key) {
    var index = _getKeyIndex(this, key);
    if (index < 0)
      return null;
    if (index === 2147483647)
      return this.c2o_1;
    return this.g2o_1[index];
  }
  p2o(key, value) {
    retry: while (true) {
      var index = _getKeyIndex(this, key);
      if (index < 0) {
        if (key === 0) {
          this.b2o_1 = true;
          this.c2o_1 = value;
          this.i2o_1 = this.i2o_1 + 1 | 0;
          return null;
        }
        if (this.i2o_1 >= this.h2o_1) {
          grow(this);
        }
        var index1 = hash1(this, key);
        if (this.f2o_1[index1] === 0)
          return setEmptySlot(this, index1, key, value);
        var index2 = hash2(this, key);
        if (this.f2o_1[index2] === 0)
          return setEmptySlot(this, index2, key, value);
        var index3 = hash3(this, key);
        if (this.f2o_1[index3] === 0)
          return setEmptySlot(this, index3, key, value);
        var inductionVariable = _get_stashStart__3psegu(this);
        var last = this.f2o_1.length;
        if (inductionVariable < last)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (this.f2o_1[n] === 0)
              return setEmptySlot(this, n, key, value);
          }
           while (inductionVariable < last);
        if (this.e2o_1 > 512) {
          grow(this);
        } else {
          growStash(this);
        }
        continue retry;
      } else if (index === 2147483647) {
        // Inline function 'kotlin.apply' call
        var this_0 = this.c2o_1;
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.IntMap.set.<anonymous>' call
        this.c2o_1 = value;
        return this_0;
      } else {
        // Inline function 'kotlin.apply' call
        var this_1 = this.g2o_1[index];
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.IntMap.set.<anonymous>' call
        this.g2o_1[index] = value;
        return this_1;
      }
    }
  }
  g3() {
    // Inline function 'kotlin.collections.Iterable' call
    return new _no_name_provided__qut3iv(this);
  }
  h3() {
    // Inline function 'kotlin.collections.Iterable' call
    return new _no_name_provided__qut3iv_0(this);
  }
  w2o(keys, offset) {
    var inductionVariable = offset;
    var last = keys.length;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(keys[n] === 0))
          return n;
      }
       while (inductionVariable < last);
    return 2147483646;
  }
  equals(other) {
    if (!(other instanceof IntMap))
      return false;
    // Inline function 'korlibs.datastructure.IntMap.fastForEachNullable' call
    // Inline function 'korlibs.datastructure.IntMap.fastKeyForEach' call
    var index = this.b2o_1 ? 2147483647 : this.w2o(this.f2o_1, 0);
    while (!(index === 2147483646)) {
      // Inline function 'korlibs.datastructure.IntMap.fastForEachNullable.<anonymous>' call
      var it;
      switch (index) {
        case 2147483647:
        case 2147483646:
          it = 0;
          break;
        default:
          it = this.f2o_1[index];
          break;
      }
      // Inline function 'korlibs.datastructure.IntMap.equals.<anonymous>' call
      var key = it;
      var value = this.d1(it);
      if (!equals(other.d1(key), value))
        return false;
      index = this.w2o(this.f2o_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return true;
  }
  hashCode() {
    var out = 0;
    // Inline function 'korlibs.datastructure.IntMap.fastForEachNullable' call
    // Inline function 'korlibs.datastructure.IntMap.fastKeyForEach' call
    var index = this.b2o_1 ? 2147483647 : this.w2o(this.f2o_1, 0);
    while (!(index === 2147483646)) {
      // Inline function 'korlibs.datastructure.IntMap.fastForEachNullable.<anonymous>' call
      var it;
      switch (index) {
        case 2147483647:
        case 2147483646:
          it = 0;
          break;
        default:
          it = this.f2o_1[index];
          break;
      }
      // Inline function 'korlibs.datastructure.IntMap.hashCode.<anonymous>' call
      var tmp = out;
      var tmp_0 = it;
      // Inline function 'kotlin.hashCode' call
      var tmp0_safe_receiver = this.d1(it);
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
      out = tmp + (tmp_0 + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0) | 0;
      index = this.w2o(this.f2o_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return out;
  }
}
class Companion_6 {
  constructor() {
    this.x2o_1 = 2147483646;
    this.y2o_1 = 2147483647;
    this.z2o_1 = 0;
  }
}
class IntIntMap {
  static l2p(nbits, loadFactor, dummy) {
    var $this = createThis(this);
    $this.a2p_1 = nbits;
    $this.b2p_1 = loadFactor;
    $this.c2p_1 = 1 << $this.a2p_1;
    $this.d2p_1 = false;
    $this.e2p_1 = 0;
    $this.f2p_1 = $this.c2p_1 - 1 | 0;
    $this.g2p_1 = 1 + imul($this.a2p_1, $this.a2p_1) | 0;
    $this.h2p_1 = new Int32Array($this.q2o());
    $this.i2p_1 = new Int32Array($this.q2o());
    $this.j2p_1 = numberToInt($this.c2p_1 * $this.b2p_1);
    $this.k2p_1 = 0;
    return $this;
  }
  static n2p(initialCapacity, loadFactor) {
    initialCapacity = initialCapacity === VOID ? 16 : initialCapacity;
    loadFactor = loadFactor === VOID ? 0.75 : loadFactor;
    // Inline function 'kotlin.math.max' call
    var b = ilog2Ceil(initialCapacity);
    var tmp$ret$0 = Math.max(4, b);
    return this.l2p(tmp$ret$0, loadFactor, true);
  }
  toString() {
    return toString(this.o2p());
  }
  q2o() {
    return this.c2p_1 + this.g2p_1 | 0;
  }
  p2p(out) {
    // Inline function 'korlibs.datastructure.IntIntMap.fastForEach' call
    // Inline function 'korlibs.datastructure.IntIntMap.fastKeyForEach' call
    var index = this.d2p_1 ? 2147483647 : this.w2o(this.h2p_1, 0);
    while (!(index === 2147483646)) {
      // Inline function 'korlibs.datastructure.IntIntMap.fastForEach.<anonymous>' call
      var it;
      switch (index) {
        case 2147483647:
        case 2147483646:
          it = 0;
          break;
        default:
          it = this.h2p_1[index];
          break;
      }
      // Inline function 'korlibs.datastructure.IntIntMap.toMap.<anonymous>' call
      var key = it;
      // Inline function 'kotlin.collections.set' call
      var value = this.d1(it);
      out.i3(key, value);
      index = this.w2o(this.h2p_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return out;
  }
  o2p(out, $super) {
    out = out === VOID ? linkedHashMapOf([]) : out;
    return $super === VOID ? this.p2p(out) : $super.p2p.call(this, out);
  }
  gp(key) {
    return _getKeyIndex_0(this, key) >= 0;
  }
  l3() {
    this.d2p_1 = false;
    this.e2p_1 = 0;
    fill(this.h2p_1, 0);
    fill(this.i2p_1, 0);
    this.k2p_1 = 0;
  }
  d1(key) {
    var index = _getKeyIndex_0(this, key);
    if (index < 0)
      return 0;
    if (index === 2147483647)
      return this.e2p_1;
    return this.i2p_1[index];
  }
  m2p(key, value) {
    retry: while (true) {
      var index = _getKeyIndex_0(this, key);
      if (index < 0) {
        if (key === 0) {
          this.d2p_1 = true;
          this.e2p_1 = value;
          this.k2p_1 = this.k2p_1 + 1 | 0;
          return 0;
        }
        if (this.k2p_1 >= this.j2p_1) {
          grow_0(this);
        }
        var index1 = hash1_0(this, key);
        if (this.h2p_1[index1] === 0)
          return setEmptySlot_0(this, index1, key, value);
        var index2 = hash2_0(this, key);
        if (this.h2p_1[index2] === 0)
          return setEmptySlot_0(this, index2, key, value);
        var index3 = hash3_0(this, key);
        if (this.h2p_1[index3] === 0)
          return setEmptySlot_0(this, index3, key, value);
        var inductionVariable = _get_stashStart__3psegu_0(this);
        var last = this.h2p_1.length;
        if (inductionVariable < last)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (this.h2p_1[n] === 0)
              return setEmptySlot_0(this, n, key, value);
          }
           while (inductionVariable < last);
        if (this.g2p_1 > 512) {
          grow_0(this);
        } else {
          growStash_0(this);
        }
        continue retry;
      } else if (index === 2147483647) {
        // Inline function 'kotlin.apply' call
        var this_0 = this.e2p_1;
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.IntIntMap.set.<anonymous>' call
        this.e2p_1 = value;
        return this_0;
      } else {
        // Inline function 'kotlin.apply' call
        var this_1 = this.i2p_1[index];
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.IntIntMap.set.<anonymous>' call
        this.i2p_1[index] = value;
        return this_1;
      }
    }
  }
  w2o(keys, offset) {
    var inductionVariable = offset;
    var last = keys.length;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(keys[n] === 0))
          return n;
      }
       while (inductionVariable < last);
    return 2147483646;
  }
  equals(other) {
    if (!(other instanceof IntIntMap))
      return false;
    // Inline function 'korlibs.datastructure.IntIntMap.fastForEach' call
    // Inline function 'korlibs.datastructure.IntIntMap.fastKeyForEach' call
    var index = this.d2p_1 ? 2147483647 : this.w2o(this.h2p_1, 0);
    while (!(index === 2147483646)) {
      // Inline function 'korlibs.datastructure.IntIntMap.fastForEach.<anonymous>' call
      var it;
      switch (index) {
        case 2147483647:
        case 2147483646:
          it = 0;
          break;
        default:
          it = this.h2p_1[index];
          break;
      }
      // Inline function 'korlibs.datastructure.IntIntMap.equals.<anonymous>' call
      var key = it;
      var value = this.d1(it);
      if (!(other.d1(key) === value))
        return false;
      index = this.w2o(this.h2p_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return true;
  }
  hashCode() {
    var out = 0;
    // Inline function 'korlibs.datastructure.IntIntMap.fastForEach' call
    // Inline function 'korlibs.datastructure.IntIntMap.fastKeyForEach' call
    var index = this.d2p_1 ? 2147483647 : this.w2o(this.h2p_1, 0);
    while (!(index === 2147483646)) {
      // Inline function 'korlibs.datastructure.IntIntMap.fastForEach.<anonymous>' call
      var it;
      switch (index) {
        case 2147483647:
        case 2147483646:
          it = 0;
          break;
        default:
          it = this.h2p_1[index];
          break;
      }
      // Inline function 'korlibs.datastructure.IntIntMap.hashCode.<anonymous>' call
      out = out + (it + this.d1(it) | 0) | 0;
      index = this.w2o(this.h2p_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return out;
  }
}
class Iterator$1 {
  constructor($hasNext, $next) {
    this.q2p_1 = $hasNext;
    this.r2p_1 = $next;
  }
  b1() {
    return this.q2p_1();
  }
  c1() {
    return this.r2p_1();
  }
}
class ListReader {
  constructor(list) {
    this.s2p_1 = list;
    this.t2p_1 = 0;
  }
  fw() {
    return this.t2p_1 >= this.s2p_1.e1();
  }
  gw() {
    return this.t2p_1 < this.s2p_1.e1();
  }
  u2p() {
    return this.s2p_1.d1(this.t2p_1);
  }
  m14(count) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.ListReader.skip.<anonymous>' call
    this.t2p_1 = this.t2p_1 + count | 0;
    return this;
  }
  k1u() {
    // Inline function 'kotlin.apply' call
    var this_0 = this.u2p();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.ListReader.read.<anonymous>' call
    this.m14(1);
    return this_0;
  }
  toString() {
    return 'ListReader(' + toString(this.s2p_1) + ')';
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof ListReader) {
      tmp_0 = equals(this.s2p_1, other.s2p_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.t2p_1 === other.t2p_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.s2p_1);
  }
}
class Companion_7 {}
class Pool {
  static z2p(reset, preallocate, gen) {
    var tmp;
    if (reset === VOID) {
      tmp = Pool$_init_$lambda_q3cbhr;
    } else {
      tmp = reset;
    }
    reset = tmp;
    preallocate = preallocate === VOID ? 0 : preallocate;
    var $this = createThis(this);
    $this.v2p_1 = reset;
    $this.w2p_1 = gen;
    $this.x2p_1 = _TGenStack___init__impl__yynjgt();
    $this.y2p_1 = 0;
    var inductionVariable = 0;
    if (inductionVariable < preallocate)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var _unary__edvuaz = $this.y2p_1;
        $this.y2p_1 = _unary__edvuaz + 1 | 0;
        TGenStack__push_impl_9yh33t($this.x2p_1, $this.w2p_1(_unary__edvuaz));
      }
       while (inductionVariable < preallocate);
    return $this;
  }
  static a2q(preallocate, gen) {
    preallocate = preallocate === VOID ? 0 : preallocate;
    return this.z2p(Pool$_init_$lambda_q3cbhr_0, preallocate, gen);
  }
  b2q() {
    return _TGenStack___get_size__impl__cvg66t(this.x2p_1);
  }
  c2q() {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!(new TGenStack(this.x2p_1)).g1()) {
      tmp = TGenStack__pop_impl_qisxa0(this.x2p_1);
    } else {
      var _unary__edvuaz = this.y2p_1;
      this.y2p_1 = _unary__edvuaz + 1 | 0;
      tmp = this.w2p_1(_unary__edvuaz);
    }
    return tmp;
  }
  l3() {
    TGenStack__clear_impl_pali4s(this.x2p_1);
    this.y2p_1 = 0;
  }
  d2q(element) {
    this.v2p_1(element);
    TGenStack__push_impl_9yh33t(this.x2p_1, element);
  }
  e2q(element) {
    if (element == null)
      return Unit_instance;
    this.d2q(element);
  }
  f2q(elements) {
    var _iterator__ex2g4s = elements.a1();
    while (_iterator__ex2g4s.b1()) {
      var element = _iterator__ex2g4s.c1();
      this.d2q(element);
    }
  }
  hashCode() {
    return TGenStack__hashCode_impl_l04zom(this.x2p_1);
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof Pool) {
      tmp_0 = equals(this.x2p_1, other.x2p_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.b2q() === other.b2q();
    } else {
      tmp = false;
    }
    return tmp;
  }
}
class ConcurrentPool extends Pool {
  static n2q(reset, preallocate, gen) {
    var tmp;
    if (reset === VOID) {
      tmp = ConcurrentPool$_init_$lambda_gqhtk8;
    } else {
      tmp = reset;
    }
    reset = tmp;
    preallocate = preallocate === VOID ? 0 : preallocate;
    var $this = this.z2p(reset, preallocate, gen);
    $this.k2q_1 = reset;
    $this.l2q_1 = gen;
    $this.m2q_1 = new NonRecursiveLock();
    return $this;
  }
  c2q() {
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.m2q_1.i1v_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    // Inline function 'korlibs.datastructure.ConcurrentPool.alloc.<anonymous>' call
    return super.c2q();
  }
  l3() {
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.m2q_1.i1v_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    super.l3();
  }
  d2q(element) {
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.m2q_1.i1v_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    super.d2q(element);
  }
}
class ReturnablePool {
  constructor(_reset, gen) {
    var tmp;
    if (_reset === VOID) {
      tmp = ReturnablePool$_init_$lambda_rsm60r;
    } else {
      tmp = _reset;
    }
    _reset = tmp;
    this.o2q_1 = _reset;
    this.p2q_1 = gen;
    this.q2q_1 = fastArrayListOf([]);
    var tmp_0 = this;
    var tmp_1 = ReturnablePool$list$lambda(this);
    tmp_0.r2q_1 = Pool.z2p(tmp_1, VOID, ReturnablePool$list$lambda_0(this));
    this.s2q_1 = this.r2q_1.c2q();
  }
  c1() {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.q2q_1;
    var element = this.s2q_1;
    this_0.h(element);
    this.s2q_1 = this.r2q_1.c2q();
    return this.s2q_1;
  }
  t2q() {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.q2q_1.qy_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.datastructure.ReturnablePool.reset.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var it = array[_unary__edvuaz];
      this.r2q_1.d2q(it);
    }
    this.q2q_1.l3();
  }
}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.u2q_1 = function_0;
  }
  ui(a, b) {
    return this.u2q_1(a, b);
  }
  compare(a, b) {
    return this.ui(a, b);
  }
  n4() {
    return this.u2q_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.n4(), other.n4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.n4());
  }
}
class Companion_8 {
  v2q(comparator, reversed_0) {
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp = fillArrayVal(Array(16), null);
    return new TGenPriorityQueue(isArray(tmp) ? tmp : THROW_CCE(), reversed_0 ? reversed(comparator) : comparator);
  }
  w2q(reversed, comparator) {
    return Companion_instance_8.v2q(new sam$kotlin_Comparator$0(comparator), reversed);
  }
  x2q(reversed, comparator, $super) {
    reversed = reversed === VOID ? false : reversed;
    return $super === VOID ? this.w2q(reversed, comparator) : $super.w2q.call(this, reversed, comparator);
  }
}
class TGenPriorityQueue$iterator$1 {
  constructor($index, this$0) {
    this.b2r_1 = $index;
    this.c2r_1 = this$0;
  }
  b1() {
    return this.b2r_1._v < this.c2r_1.a2r_1;
  }
  c1() {
    var _unary__edvuaz = this.b2r_1._v;
    this.b2r_1._v = _unary__edvuaz + 1 | 0;
    return _get_value__a43j40(_PriorityQueueNode___init__impl__34dlfu(_unary__edvuaz), this.c2r_1);
  }
  g1b() {
    throw NotImplementedError.td();
  }
  j6() {
    return this.g1b();
  }
}
class TGenPriorityQueue {
  constructor(data, comparator) {
    this.y2q_1 = data;
    this.z2q_1 = comparator;
    this.a2r_1 = 0;
  }
  e1() {
    return this.a2r_1;
  }
  d2r() {
    if (this.a2r_1 <= 0)
      throw IndexOutOfBoundsException.be();
    return this.y2q_1[0];
  }
  g2m(element) {
    this.a2r_1 = this.a2r_1 + 1 | 0;
    ensure_1(this, this.a2r_1);
    var i = _PriorityQueueNode___init__impl__34dlfu(this.a2r_1 - 1 | 0);
    _set_value__lx0xdg(i, this, element);
    while (!_get_isRoot__1006zj(i, this) && gt(this, _get_value__a43j40(_get_parent__oo9xup(i, this), this), _get_value__a43j40(i, this))) {
      swap_0(this, i, _get_parent__oo9xup(i, this));
      i = _get_parent__oo9xup(i, this);
    }
    return true;
  }
  h(element) {
    return this.g2m((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  e2r() {
    if (this.a2r_1 <= 0)
      throw IndexOutOfBoundsException.be();
    if (this.a2r_1 === 1) {
      this.a2r_1 = this.a2r_1 - 1 | 0;
      return _get_value__a43j40(_PriorityQueueNode___init__impl__34dlfu(0), this);
    }
    var root = _get_value__a43j40(_PriorityQueueNode___init__impl__34dlfu(0), this);
    _set_value__lx0xdg(_PriorityQueueNode___init__impl__34dlfu(0), this, _get_value__a43j40(_PriorityQueueNode___init__impl__34dlfu(this.a2r_1 - 1 | 0), this));
    this.a2r_1 = this.a2r_1 - 1 | 0;
    minHeapify(this, 0);
    return root;
  }
  i2m(element) {
    var inductionVariable = 0;
    var last = this.a2r_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals(this.y2q_1[n], element))
          return n;
      }
       while (inductionVariable < last);
    return -1;
  }
  h2m(element) {
    var index = this.i2m(element);
    if (index >= 0) {
      this.f2r(index);
    }
    return index >= 0;
  }
  m3(element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.h2m((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  f2r(index) {
    var i = _PriorityQueueNode___init__impl__34dlfu(index);
    while (!(_PriorityQueueNode___get_index__impl__b6r7i5(i) === 0)) {
      swap_0(this, i, _get_parent__oo9xup(i, this));
      i = _get_parent__oo9xup(i, this);
    }
    this.e2r();
  }
  l2m(element) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var this_0 = until(0, this.a2r_1);
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.g1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var inductionVariable = this_0.d2_1;
      var last = this_0.e2_1;
      if (inductionVariable <= last)
        do {
          var element_0 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.datastructure.TGenPriorityQueue.contains.<anonymous>' call
          var it = element_0;
          if (equals(_get_value__a43j40(_PriorityQueueNode___init__impl__34dlfu(it), this), element)) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
        }
         while (!(element_0 === last));
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  }
  z2(element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.l2m((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  m2m(elements) {
    var thisSet = toSet(this);
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.g1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = elements.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.datastructure.TGenPriorityQueue.containsAll.<anonymous>' call
        if (!thisSet.z2(element)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  a3(elements) {
    return this.m2m(elements);
  }
  g1() {
    return this.a2r_1 === 0;
  }
  b2m(elements) {
    var _iterator__ex2g4s = elements.a1();
    while (_iterator__ex2g4s.b1()) {
      var e = _iterator__ex2g4s.c1();
      this.g2m(e);
    }
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !elements.g1();
  }
  f1(elements) {
    return this.b2m(elements);
  }
  a1() {
    var index = {_v: 0};
    return new TGenPriorityQueue$iterator$1(index, this);
  }
  toString() {
    return toString(toList(this));
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof TGenPriorityQueue) {
      tmp_0 = contentEquals_1(this.y2q_1, other.y2q_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.z2q_1, other.z2q_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return contentHashCode_1(this.y2q_1);
  }
}
class TGenQueue {
  constructor() {
    this.g2r_1 = TGenDeque.x2l();
  }
  e1() {
    return this.g2r_1.e1();
  }
  g1() {
    return this.e1() === 0;
  }
  h2r(v) {
    this.g2r_1.y2l(v);
  }
  i2r() {
    return this.g2r_1.qk();
  }
  l2m(element) {
    return this.g2r_1.l2m(element);
  }
  z2(element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.l2m((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  m2m(elements) {
    return this.g2r_1.m2m(elements);
  }
  a3(elements) {
    return this.m2m(elements);
  }
  a1() {
    return this.g2r_1.a1();
  }
  hashCode() {
    return this.g2r_1.hashCode();
  }
  equals(other) {
    var tmp;
    if (other instanceof TGenQueue) {
      tmp = this.g2r_1.equals(other.g2r_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
}
class Ref$1 {
  j2r(_set____db54di) {
    this.k2r_1 = _set____db54di;
  }
  u1() {
    var tmp = this.k2r_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('value');
    }
  }
}
class Ref$2 {
  constructor($prop) {
    this.l2r_1 = $prop;
  }
  j2r(value) {
    this.l2r_1.set(value);
  }
  u1() {
    return this.l2r_1.get();
  }
}
class Companion_9 {}
class TGenStack {
  constructor(items) {
    this.m2r_1 = items;
  }
  e1() {
    return _TGenStack___get_size__impl__cvg66t(this.m2r_1);
  }
  g1() {
    return TGenStack__isEmpty_impl_bsbpyi(this.m2r_1);
  }
  l2m(element) {
    return TGenStack__contains_impl_l8kli6(this.m2r_1, element);
  }
  z2(element) {
    return TGenStack__contains_impl_l8kli6_0(this, element);
  }
  m2m(elements) {
    return TGenStack__containsAll_impl_ic9i7r(this.m2r_1, elements);
  }
  a3(elements) {
    return TGenStack__containsAll_impl_ic9i7r_0(this, elements);
  }
  a1() {
    return TGenStack__iterator_impl_2pdia5(this.m2r_1);
  }
  toString() {
    return TGenStack__toString_impl_s9t5hn(this.m2r_1);
  }
  hashCode() {
    return TGenStack__hashCode_impl_l04zom(this.m2r_1);
  }
  equals(other) {
    return TGenStack__equals_impl_w9i35u(this.m2r_1, other);
  }
}
class SyncPauseable {
  constructor() {
    this.n2r_1 = new Lock();
    this.o2r_1 = false;
  }
  p2r(value) {
    if (!(this.o2r_1 === value)) {
      this.o2r_1 = value;
      // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
      var this_0 = this.n2r_1;
      $l$block: {
        // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
        this_0.n1v();
        try {
          this.n2r_1.r1v();
          break $l$block;
        }finally {
          this_0.p1v();
        }
      }
    }
  }
}
class Memory {
  s2l(src, srcPos, dst, dstPos, size) {
    // Inline function 'kotlin.collections.copyInto' call
    var destination = isArray(dst) ? dst : THROW_CCE();
    var endIndex = srcPos + size | 0;
    arrayCopy(src, destination, dstPos, srcPos, endIndex);
  }
  m2k(src, srcPos, dst, dstPos, size) {
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = srcPos + size | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = src;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
  }
  u2j(src, srcPos, dst, dstPos, size) {
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = srcPos + size | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = src;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
  }
  h2l(src, srcPos, dst, dstPos, size) {
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = srcPos + size | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = src;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
  }
}
class PointList {}
function get_dimensions() {
  return 2;
}
function isEmpty() {
  return this.e1() === 0;
}
function getX(index) {
  return this.y27(index, 0);
}
function getY(index) {
  return this.y27(index, 1);
}
function get_1(index) {
  return Vector2D.w27(this.y27(index, 0), this.y27(index, 1));
}
function getComponentList(component, out) {
  var inductionVariable = 0;
  var last = this.e1();
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      out[n] = this.y27(n, component);
    }
     while (inductionVariable < last);
  return out;
}
function getComponentList$default(component, out, $super) {
  out = out === VOID ? new Float64Array(this.e1()) : out;
  return $super === VOID ? this.q2r(component, out) : getComponentList(component, out);
}
function get_first() {
  return this.d1(0);
}
function get_last() {
  return this.d1(this.e1() - 1 | 0);
}
function contains(p) {
  return this.o2e(p.m25_1, p.n25_1);
}
function contains_0(x, y) {
  var inductionVariable = 0;
  var last = this.e1();
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (this.t27(n) === x && this.u27(n) === y)
        return true;
    }
     while (inductionVariable < last);
  return false;
}
function clone(out) {
  out.w2r(this);
  return out;
}
function clone$default(out, $super) {
  out = out === VOID ? new PointArrayList(this.e1()) : out;
  return $super === VOID ? this.s2r(out) : clone(out);
}
class Companion_10 {}
class PointArrayList {
  constructor(capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    this.t2r_1 = new Mixin();
    this.u2r_1 = false;
    this.v2r_1 = DoubleArrayList.w2k(imul(capacity, 2));
  }
  ay(_set____db54di) {
    this.t2r_1.ay(_set____db54di);
  }
  by() {
    return this.t2r_1.by();
  }
  e1() {
    return this.v2r_1.e1() / 2 | 0;
  }
  y27(index_0, dim) {
    return this.v2r_1.ux(index(this, index_0, dim));
  }
  t27(index_0) {
    return this.v2r_1.ux(index(this, index_0, 0));
  }
  u27(index_0) {
    return this.v2r_1.ux(index(this, index_0, 1));
  }
  d1(index_0) {
    var i = index(this, index_0, 0);
    return Vector2D.w27(this.v2r_1.ux(i), this.v2r_1.ux(i + 1 | 0));
  }
  zg() {
    this.v2r_1.l3();
    return this;
  }
  y2r(x, y) {
    this.v2r_1.b2l(x, y);
    return this;
  }
  z2r(p) {
    return this.y2r(p.m25_1, p.n25_1);
  }
  a2s(p) {
    return this.b2s(p);
  }
  b2s(p) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.PointArrayList.addAll.<anonymous>' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < p.e1()) {
      // Inline function 'korlibs.math.geom.PointArrayList.addAll.<anonymous>.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var destruct = p.d1(_unary__edvuaz);
      var x = destruct.jl();
      var y = destruct.kl();
      this.y2r(x, y);
    }
    return this;
  }
  c2s(p, index) {
    this.y2r(p.t27(index), p.u27(index));
  }
  w2r(other) {
    this.zg();
    this.a2s(other);
    return this;
  }
  s2r(out) {
    return out.zg().a2s(this);
  }
  s2k(index_0, count) {
    this.v2r_1.s2k(index(this, index_0, 0), imul(count, 2));
    return this;
  }
  d2s(index, count, $super) {
    count = count === VOID ? 1 : count;
    return $super === VOID ? this.s2k(index, count) : $super.s2k.call(this, index, count);
  }
  equals(other) {
    var tmp;
    if (other instanceof PointArrayList) {
      tmp = this.v2r_1.equals(other.v2r_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return this.v2r_1.hashCode();
  }
  toString() {
    var sb = StringBuilder.f();
    sb.ub(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var _destruct__k2r9zo = this.d1(n);
        var x = _destruct__k2r9zo.jl();
        var y = _destruct__k2r9zo.kl();
        if (!(n === 0)) {
          sb.tb(', ');
        }
        sb.ub(_Char___init__impl__6a9atx(40));
        if (x === round(x))
          sb.sg(numberToInt(x));
        else
          sb.vg(x);
        sb.tb(', ');
        if (y === round(y))
          sb.sg(numberToInt(y));
        else
          sb.vg(y);
        sb.ub(_Char___init__impl__6a9atx(41));
      }
       while (inductionVariable < last);
    sb.ub(_Char___init__impl__6a9atx(93));
    return sb.toString();
  }
  z2(element) {
    if (!(element instanceof Vector2D))
      return false;
    return this.s27(element instanceof Vector2D ? element : THROW_CCE());
  }
  ex(other, epsilon) {
    return this.z27((!(other == null) ? isInterface(other, IDoubleVectorList) : false) ? other : THROW_CCE(), epsilon);
  }
  a3(elements) {
    return this.q27(elements);
  }
  l1(element) {
    if (!(element instanceof Vector2D))
      return -1;
    return this.o27(element instanceof Vector2D ? element : THROW_CCE());
  }
}
class DoubleVectorArrayList {
  constructor(dimensions, capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    this.e2s_1 = new Mixin();
    this.f2s_1 = dimensions;
    this.g2s_1 = DoubleArrayList.w2k(imul(capacity, this.f2s_1));
    this.h2s_1 = false;
  }
  ay(_set____db54di) {
    this.e2s_1.ay(_set____db54di);
  }
  by() {
    return this.e2s_1.by();
  }
  a28() {
    return this.f2s_1;
  }
  e1() {
    return this.g2s_1.e1() / this.f2s_1 | 0;
  }
  y27(index, dim) {
    return this.g2s_1.d1(imul(index, this.f2s_1) + dim | 0);
  }
  b2l(v0, v1) {
    // Inline function 'kotlin.also' call
    checkDimensions(this, 2);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.DoubleVectorArrayList.add.<anonymous>' call
    this.g2s_1.b2l(v0, v1);
    return Unit_instance;
  }
  c2l(v0, v1, v2, v3) {
    // Inline function 'kotlin.also' call
    checkDimensions(this, 4);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.DoubleVectorArrayList.add.<anonymous>' call
    this.g2s_1.c2l(v0, v1, v2, v3);
    return Unit_instance;
  }
  d2l(v0, v1, v2, v3, v4, v5) {
    // Inline function 'kotlin.also' call
    checkDimensions(this, 6);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.DoubleVectorArrayList.add.<anonymous>' call
    this.g2s_1.d2l(v0, v1, v2, v3, v4, v5);
    return Unit_instance;
  }
  i2s(index, out, roundDecimalPlaces) {
    appendGenericArray(out, this.f2s_1, DoubleVectorArrayList$vectorToStringBuilder$lambda(this, index, roundDecimalPlaces));
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof DoubleVectorArrayList) {
      tmp_0 = this.f2s_1 === other.f2s_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.g2s_1.equals(other.g2s_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return this.g2s_1.hashCode();
  }
  toString() {
    return this.j2s(null);
  }
  j2s(roundDecimalPlaces) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.DoubleVectorArrayList.toString.<anonymous>' call
    this_0.tb('VectorArrayList[' + this.e1() + '](\n');
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n === 0)) {
          this_0.tb(', \n');
        }
        this_0.tb('   ');
        this.i2s(n, this_0, roundDecimalPlaces);
      }
       while (inductionVariable < last);
    this_0.tb('\n)');
    return this_0.toString();
  }
  l3() {
    this.g2s_1.l3();
  }
  ex(other, epsilon) {
    return this.z27((!(other == null) ? isInterface(other, IDoubleVectorList) : false) ? other : THROW_CCE(), epsilon);
  }
}
class Companion_11 {}
class PointIntArrayList {
  constructor(capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    this.k2s_1 = new Mixin();
    this.l2s_1 = false;
    this.m2s_1 = IntArrayList.a2k(capacity);
    this.n2s_1 = IntArrayList.a2k(capacity);
  }
  ay(_set____db54di) {
    this.k2s_1.ay(_set____db54di);
  }
  by() {
    return this.k2s_1.by();
  }
  e1() {
    return this.m2s_1.e1();
  }
  g1() {
    return this.e1() === 0;
  }
  l3() {
    this.m2s_1.l3();
    this.n2s_1.l3();
  }
  o2s(x, y) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.PointIntArrayList.add.<anonymous>' call
    this.m2s_1.j2k(x);
    this.n2s_1.j2k(y);
    return this;
  }
  p2s(p) {
    return this.o2s(p.q2f_1, p.r2f_1);
  }
  t27(index) {
    return this.m2s_1.ux(index);
  }
  u27(index) {
    return this.n2s_1.ux(index);
  }
  toString() {
    var sb = StringBuilder.f();
    sb.ub(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var x = this.t27(n);
        var y = this.u27(n);
        if (!(n === 0)) {
          sb.tb(', ');
        }
        sb.ub(_Char___init__impl__6a9atx(40));
        sb.sg(x);
        sb.tb(', ');
        sb.sg(y);
        sb.ub(_Char___init__impl__6a9atx(41));
      }
       while (inductionVariable < last);
    sb.ub(_Char___init__impl__6a9atx(93));
    return sb.toString();
  }
}
//endregion
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
function swap(_this__u8e3s4, lIndex, rIndex) {
  var temp = _this__u8e3s4[lIndex];
  _this__u8e3s4[lIndex] = _this__u8e3s4[rIndex];
  _this__u8e3s4[rIndex] = temp;
}
function rotateRight(_this__u8e3s4, offset) {
  offset = offset === VOID ? 1 : offset;
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure._rotateRight' call
    var size = _this__u8e3s4.length;
    var offset_0 = umod(offset, size);
    if (offset_0 === 0) {
      tmp$ret$0 = Unit_instance;
      break $l$block;
    }
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(1 <= offset_0 ? offset_0 < size : false)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.z4(toString(message));
    }
    // Inline function 'korlibs.datastructure.rotateRight.<anonymous>' call
    reverse(_this__u8e3s4, 0, size);
    // Inline function 'korlibs.datastructure.rotateRight.<anonymous>' call
    reverse(_this__u8e3s4, 0, offset_0);
    // Inline function 'korlibs.datastructure.rotateRight.<anonymous>' call
    reverse(_this__u8e3s4, offset_0, size);
  }
  return tmp$ret$0;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
function ensure($this, count) {
  if (($this.o2j_1 + count | 0) > $this.n2j_1.length) {
    var tmp = $this;
    var tmp_0 = $this.n2j_1;
    // Inline function 'kotlin.math.max' call
    var a = $this.o2j_1 + count | 0;
    var b = imul($this.n2j_1.length, 3);
    var tmp$ret$0 = Math.max(a, b);
    var tmp_1 = copyOf(tmp_0, tmp$ret$0);
    tmp.n2j_1 = isFloatArray(tmp_1) ? tmp_1 : THROW_CCE();
  }
}
var Companion_instance_2;
function Companion_getInstance_2() {
  return Companion_instance_2;
}
var Companion_instance_3;
function Companion_getInstance_3() {
  return Companion_instance_3;
}
function ensure_0($this, count) {
  if (($this.v2k_1 + count | 0) > $this.u2k_1.length) {
    var tmp = $this;
    var tmp_0 = $this.u2k_1;
    // Inline function 'kotlin.math.max' call
    var a = $this.v2k_1 + count | 0;
    var b = imul($this.u2k_1.length, 3);
    var tmp$ret$0 = Math.max(a, b);
    var tmp_1 = copyOf_1(tmp_0, tmp$ret$0);
    tmp.u2k_1 = isDoubleArray(tmp_1) ? tmp_1 : THROW_CCE();
  }
}
function intArrayListOf(values) {
  return IntArrayList.e2k(values.slice());
}
function toIntArrayList(_this__u8e3s4) {
  return IntArrayList.e2k(_this__u8e3s4.slice());
}
function floatArrayListOf(values) {
  return FloatArrayList.q2j(values.slice());
}
function doubleArrayListOf(values) {
  return DoubleArrayList.z2k(values.slice());
}
function sort(_this__u8e3s4, start, end, reversed) {
  start = start === VOID ? 0 : start;
  end = end === VOID ? _this__u8e3s4.e1() : end;
  reversed = reversed === VOID ? false : reversed;
  return genericSort_0(_this__u8e3s4, start, end - 1 | 0, DoubleArrayListSortOps_getInstance(), reversed);
}
function reverse_0(_this__u8e3s4, start, end) {
  start = start === VOID ? 0 : start;
  end = end === VOID ? _this__u8e3s4.e1() : end;
  return DoubleArrayListSortOps_getInstance().j2l(_this__u8e3s4, start, end - 1 | 0);
}
var DoubleArrayListSortOps_instance;
function DoubleArrayListSortOps_getInstance() {
  if (DoubleArrayListSortOps_instance === VOID)
    new DoubleArrayListSortOps();
  return DoubleArrayListSortOps_instance;
}
function _get__data__kyoi3c($this) {
  // Inline function 'korlibs.datastructure.fastCastTo' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return $this.r2l_1;
}
function _get_capacity__a9k9f3($this) {
  return $this.r2l_1.length;
}
function resizeIfRequiredFor($this, count) {
  if (($this.e1() + count | 0) > _get_capacity__a9k9f3($this)) {
    var i = $this.r2l_1;
    var istart = $this.p2l_1;
    // Inline function 'kotlin.arrayOfNulls' call
    // Inline function 'kotlin.comparisons.maxOf' call
    var a = $this.r2l_1.length + 7 | 0;
    // Inline function 'kotlin.comparisons.maxOf' call
    var a_0 = $this.e1() + count | 0;
    var b = imul($this.r2l_1.length, 2);
    var b_0 = Math.max(a_0, b);
    var size = Math.max(a, b_0);
    var _o = fillArrayVal(Array(size), null);
    var o = isArray(_o) ? _o : THROW_CCE();
    copyCyclic($this, i, istart, o, $this.q2l_1);
    $this.r2l_1 = o;
    $this.p2l_1 = 0;
  }
}
function copyCyclic($this, i, istart, o, count) {
  // Inline function 'kotlin.math.min' call
  var a = i.length - istart | 0;
  var size1 = Math.min(a, count);
  var size2 = count - size1 | 0;
  Memory_instance.s2l(i, istart, o, 0, size1);
  if (size2 > 0) {
    Memory_instance.s2l(i, 0, o, size1, size2);
  }
}
function _addLast($this, item) {
  $this.r2l_1[($this.p2l_1 + $this.q2l_1 | 0) % _get_capacity__a9k9f3($this) | 0] = item;
  $this.q2l_1 = $this.q2l_1 + 1 | 0;
}
function nullify($this, index) {
  _get__data__kyoi3c($this)[index] = null;
}
function _removeRetainAll($this, elements, retain) {
  var eset = toSet(elements);
  // Inline function 'kotlin.collections.copyOf' call
  // Inline function 'kotlin.js.asDynamic' call
  var _temp = $this.r2l_1.slice();
  var tsize = 0;
  var osize = $this.e1();
  var inductionVariable = 0;
  var last = $this.e1();
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var c = $this.d1(n);
      if (eset.z2(c) === retain) {
        var _unary__edvuaz = tsize;
        tsize = _unary__edvuaz + 1 | 0;
        _temp[_unary__edvuaz] = c;
      }
    }
     while (inductionVariable < last);
  $this.r2l_1 = _temp;
  $this.p2l_1 = 0;
  $this.q2l_1 = tsize;
  return !(tsize === osize);
}
function internalIndex($this, index) {
  return umod($this.p2l_1 + index | 0, _get_capacity__a9k9f3($this));
}
function _get__data__kyoi3c_0($this) {
  // Inline function 'korlibs.datastructure.fastCastTo' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return $this.p2m_1;
}
function _get_capacity__a9k9f3_0($this) {
  return $this.p2m_1.length;
}
function resizeIfRequiredFor_0($this, count) {
  if (($this.e1() + count | 0) > _get_capacity__a9k9f3_0($this)) {
    var i = $this.p2m_1;
    var istart = $this.n2m_1;
    // Inline function 'kotlin.comparisons.maxOf' call
    var a = $this.p2m_1.length + 7 | 0;
    // Inline function 'kotlin.comparisons.maxOf' call
    var a_0 = $this.e1() + count | 0;
    var b = imul($this.p2m_1.length, 2);
    var b_0 = Math.max(a_0, b);
    var tmp$ret$1 = Math.max(a, b_0);
    var _o = new Int32Array(tmp$ret$1);
    var o = isIntArray(_o) ? _o : THROW_CCE();
    copyCyclic_0($this, i, istart, o, $this.o2m_1);
    $this.p2m_1 = o;
    $this.n2m_1 = 0;
  }
}
function copyCyclic_0($this, i, istart, o, count) {
  // Inline function 'kotlin.math.min' call
  var a = i.length - istart | 0;
  var size1 = Math.min(a, count);
  var size2 = count - size1 | 0;
  Memory_instance.m2k(i, istart, o, 0, size1);
  if (size2 > 0) {
    Memory_instance.m2k(i, 0, o, size1, size2);
  }
}
function _addLast_0($this, item) {
  $this.p2m_1[($this.n2m_1 + $this.o2m_1 | 0) % _get_capacity__a9k9f3_0($this) | 0] = item;
  $this.o2m_1 = $this.o2m_1 + 1 | 0;
}
function nullify_0($this, index) {
  _get__data__kyoi3c_0($this)[index] = 0;
}
function internalIndex_0($this, index) {
  return umod($this.n2m_1 + index | 0, _get_capacity__a9k9f3_0($this));
}
function toDeque(_this__u8e3s4) {
  return Deque(_this__u8e3s4);
}
function Deque(other) {
  // Inline function 'kotlin.also' call
  var this_0 = TGenDeque.w2l(other.e1());
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.Deque.<anonymous>' call
  this_0.b2m(other);
  return this_0;
}
function getAndRemove(_this__u8e3s4, key) {
  // Inline function 'kotlin.also' call
  var this_0 = get_2(_this__u8e3s4, key);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.getAndRemove.<anonymous>' call
  remove(_this__u8e3s4, key);
  return this_0;
}
function get_keys(_this__u8e3s4) {
  return keys(_this__u8e3s4);
}
function translateIndex(_this__u8e3s4, $this) {
  if (!(0 <= _this__u8e3s4 ? _this__u8e3s4 < $this.e1() : false))
    throw IndexOutOfBoundsException.q1('' + _this__u8e3s4);
  return $this.j2n_1 + _this__u8e3s4 | 0;
}
var Companion_instance_4;
function Companion_getInstance_4() {
  return Companion_instance_4;
}
function IArray2$asString$lambda(this$0) {
  return function (y) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this$0.z2i());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.d2_1;
    var last = this_0.e2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.datastructure.IArray2.asString.<anonymous>.<anonymous>' call
        var x = item;
        var tmp$ret$0 = this$0.g2j(x, y);
        destination.h(tmp$ret$0);
      }
       while (!(item === last));
    return joinToString(destination, ', ');
  };
}
function indexOr(_this__u8e3s4, x, y, invalid) {
  invalid = invalid === VOID ? -1 : invalid;
  if (!(0 <= x ? x < _this__u8e3s4.z2i() : false) || !(0 <= y ? y < _this__u8e3s4.a2j() : false))
    return invalid;
  return imul(y, _this__u8e3s4.z2i()) + x | 0;
}
function currentKey($this) {
  switch ($this.w2n_1) {
    case 2147483647:
    case 2147483646:
      return 0;
    default:
      return $this.v2n_1.f2o_1[$this.w2n_1];
  }
}
function currentValue($this) {
  switch ($this.w2n_1) {
    case 2147483647:
      return $this.v2n_1.c2o_1;
    case 2147483646:
      return null;
    default:
      return $this.v2n_1.g2o_1[$this.w2n_1];
  }
}
function nextNonEmptyIndex($this, keys, offset) {
  var inductionVariable = offset;
  var last = keys.length;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (!(keys[n] === 0))
        return n;
    }
     while (inductionVariable < last);
  return 2147483646;
}
function next($this) {
  if (!($this.w2n_1 === 2147483646))
    $this.w2n_1 = nextNonEmptyIndex($this, $this.v2n_1.f2o_1, $this.w2n_1 === 2147483647 ? 0 : $this.w2n_1 + 1 | 0);
}
function IntMap$_get_keys_$o$iterator$lambda_bn8atq($it) {
  return function () {
    return $it.b1();
  };
}
function IntMap$_get_keys_$o$iterator$lambda_bn8atq_0($it) {
  return function () {
    return $it.j2o();
  };
}
function IntMap$_get_values_$o$iterator$lambda_ggo058($it) {
  return function () {
    return $it.b1();
  };
}
function IntMap$_get_values_$o$iterator$lambda_ggo058_0($it) {
  return function () {
    return $it.k2o();
  };
}
var Companion_instance_5;
function Companion_getInstance_5() {
  return Companion_instance_5;
}
function _get_stashStart__3psegu($this) {
  return $this.f2o_1.length - $this.e2o_1 | 0;
}
function grow($this) {
  var inc = $this.y2n_1 < 20 ? 3 : 1;
  var newnbits = $this.y2n_1 + inc | 0;
  var new_0 = IntMap.o2o(newnbits, $this.z2n_1, true);
  var inductionVariable = 0;
  var last = $this.f2o_1.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var k = $this.f2o_1[n];
      if (!(k === 0)) {
        new_0.p2o(k, $this.g2o_1[n]);
      }
    }
     while (inductionVariable <= last);
  $this.y2n_1 = new_0.y2n_1;
  $this.a2o_1 = new_0.a2o_1;
  $this.d2o_1 = new_0.d2o_1;
  $this.e2o_1 = new_0.e2o_1;
  $this.f2o_1 = new_0.f2o_1;
  $this.g2o_1 = new_0.g2o_1;
  $this.h2o_1 = new_0.h2o_1;
}
function growStash($this) {
  $this.e2o_1 = imul($this.e2o_1, 2);
  $this.f2o_1 = copyOf_0($this.f2o_1, $this.q2o());
  $this.g2o_1 = copyOf_2($this.g2o_1, $this.q2o());
}
function _getKeyIndex($this, key) {
  if (key === 0)
    return $this.b2o_1 ? 2147483647 : -1;
  var index1 = hash1($this, key);
  if ($this.f2o_1[index1] === key)
    return index1;
  var index2 = hash2($this, key);
  if ($this.f2o_1[index2] === key)
    return index2;
  var index3 = hash3($this, key);
  if ($this.f2o_1[index3] === key)
    return index3;
  var inductionVariable = _get_stashStart__3psegu($this);
  var last = $this.f2o_1.length;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if ($this.f2o_1[n] === key)
        return n;
    }
     while (inductionVariable < last);
  return -1;
}
function setEmptySlot($this, index, key, value) {
  if (!($this.f2o_1[index] === 0))
    throw IllegalStateException.q5();
  $this.f2o_1[index] = key;
  $this.g2o_1[index] = value;
  $this.i2o_1 = $this.i2o_1 + 1 | 0;
  return null;
}
function hash1($this, key) {
  return _hash1(key, $this.d2o_1);
}
function hash2($this, key) {
  return _hash2(key, $this.d2o_1);
}
function hash3($this, key) {
  return _hash3(key, $this.d2o_1);
}
var Companion_instance_6;
function Companion_getInstance_6() {
  return Companion_instance_6;
}
function _get_stashStart__3psegu_0($this) {
  return $this.h2p_1.length - $this.g2p_1 | 0;
}
function grow_0($this) {
  var inc = $this.a2p_1 < 20 ? 3 : 1;
  var newnbits = $this.a2p_1 + inc | 0;
  var new_0 = IntIntMap.l2p(newnbits, $this.b2p_1, true);
  var inductionVariable = 0;
  var last = $this.h2p_1.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var k = $this.h2p_1[n];
      if (!(k === 0)) {
        new_0.m2p(k, $this.i2p_1[n]);
      }
    }
     while (inductionVariable <= last);
  $this.a2p_1 = new_0.a2p_1;
  $this.c2p_1 = new_0.c2p_1;
  $this.f2p_1 = new_0.f2p_1;
  $this.g2p_1 = new_0.g2p_1;
  $this.h2p_1 = new_0.h2p_1;
  $this.i2p_1 = new_0.i2p_1;
  $this.j2p_1 = new_0.j2p_1;
}
function growStash_0($this) {
  $this.g2p_1 = imul($this.g2p_1, 2);
  $this.h2p_1 = copyOf_0($this.h2p_1, $this.q2o());
  $this.i2p_1 = copyOf_0($this.i2p_1, $this.q2o());
}
function _getKeyIndex_0($this, key) {
  if (key === 0)
    return $this.d2p_1 ? 2147483647 : -1;
  var index1 = hash1_0($this, key);
  if ($this.h2p_1[index1] === key)
    return index1;
  var index2 = hash2_0($this, key);
  if ($this.h2p_1[index2] === key)
    return index2;
  var index3 = hash3_0($this, key);
  if ($this.h2p_1[index3] === key)
    return index3;
  var inductionVariable = _get_stashStart__3psegu_0($this);
  var last = $this.h2p_1.length;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if ($this.h2p_1[n] === key)
        return n;
    }
     while (inductionVariable < last);
  return -1;
}
function setEmptySlot_0($this, index, key, value) {
  if (!($this.h2p_1[index] === 0))
    throw IllegalStateException.q5();
  $this.h2p_1[index] = key;
  $this.i2p_1[index] = value;
  $this.k2p_1 = $this.k2p_1 + 1 | 0;
  return 0;
}
function hash1_0($this, key) {
  return _hash1(key, $this.f2p_1);
}
function hash2_0($this, key) {
  return _hash2(key, $this.f2p_1);
}
function hash3_0($this, key) {
  return _hash3(key, $this.f2p_1);
}
function toIntMap(_this__u8e3s4) {
  var out = IntMap.v2o(numberToInt(_this__u8e3s4.e1() * 1.25));
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = _this__u8e3s4.s1().a1();
  while (_iterator__ex2g4s.b1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.c1();
    // Inline function 'kotlin.collections.component1' call
    var k = _destruct__k2r9zo.t1();
    // Inline function 'kotlin.collections.component2' call
    var v = _destruct__k2r9zo.u1();
    out.p2o(k, v);
  }
  return out;
}
function _hash1(key, mask) {
  return _mask(key, mask);
}
function _hash2(key, mask) {
  return _mask(imul(key, 1294968109), mask);
}
function _hash3(key, mask) {
  return _mask(imul(key, 294969449), mask);
}
function _mask(value, mask) {
  return (((value + ((value >>> 8 | 0) & 255) | 0) + ((value >>> 16 | 0) & 255) | 0) + (value >> 24 & 255) | 0) & mask;
}
function associateByInt(_this__u8e3s4, block) {
  var n = 0;
  var out = IntMap.v2o();
  var _iterator__ex2g4s = _this__u8e3s4.a1();
  while (_iterator__ex2g4s.b1()) {
    var it = _iterator__ex2g4s.c1();
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    out.p2o(block(_unary__edvuaz, it), it);
  }
  return out;
}
function Iterator_0(hasNext, next) {
  return new Iterator$1(hasNext, next);
}
var Companion_instance_7;
function Companion_getInstance_7() {
  return Companion_instance_7;
}
function Pool$_init_$lambda_q3cbhr(it) {
  return Unit_instance;
}
function Pool$_init_$lambda_q3cbhr_0(it) {
  return Unit_instance;
}
function ConcurrentPool$_init_$lambda_gqhtk8(it) {
  return Unit_instance;
}
function ReturnablePool$_init_$lambda_rsm60r(it) {
  return Unit_instance;
}
function ReturnablePool$list$lambda(this$0) {
  return function (it) {
    this$0.o2q_1(it);
    return Unit_instance;
  };
}
function ReturnablePool$list$lambda_0(this$0) {
  return function (it) {
    return this$0.p2q_1(it);
  };
}
var Companion_instance_8;
function Companion_getInstance_8() {
  return Companion_instance_8;
}
function _set_value__lx0xdg(_this__u8e3s4, $this, value) {
  $this.y2q_1[_PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4)] = value;
}
function _get_value__a43j40(_this__u8e3s4, $this) {
  return $this.y2q_1[_PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4)];
}
function _get_isRoot__1006zj(_this__u8e3s4, $this) {
  return _PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4) === 0;
}
function _get_parent__oo9xup(_this__u8e3s4, $this) {
  return _PriorityQueueNode___init__impl__34dlfu((_PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4) - 1 | 0) / 2 | 0);
}
function _get_left__d9qyp0(_this__u8e3s4, $this) {
  return _PriorityQueueNode___init__impl__34dlfu(imul(2, _PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4)) + 1 | 0);
}
function _get_right__bvz45n(_this__u8e3s4, $this) {
  return _PriorityQueueNode___init__impl__34dlfu(imul(2, _PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4)) + 2 | 0);
}
function gt($this, a, b) {
  return $this.z2q_1.compare(a, b) > 0;
}
function lt($this, a, b) {
  return $this.z2q_1.compare(a, b) < 0;
}
function _get_capacity__a9k9f3_1($this) {
  return $this.y2q_1.length;
}
function ensure_1($this, index) {
  if (index >= _get_capacity__a9k9f3_1($this)) {
    var tmp = $this;
    var tmp_0 = copyOf_2($this.y2q_1, 2 + imul(_get_capacity__a9k9f3_1($this), 2) | 0);
    tmp.y2q_1 = isArray(tmp_0) ? tmp_0 : THROW_CCE();
  }
}
function minHeapify($this, index) {
  var i = _PriorityQueueNode___init__impl__34dlfu(index);
  $l$loop: while (true) {
    var left = _get_left__d9qyp0(i, $this);
    var right = _get_right__bvz45n(i, $this);
    var smallest = i;
    if (_PriorityQueueNode___get_index__impl__b6r7i5(left) < $this.a2r_1 && lt($this, _get_value__a43j40(left, $this), _get_value__a43j40(i, $this)))
      smallest = left;
    if (_PriorityQueueNode___get_index__impl__b6r7i5(right) < $this.a2r_1 && lt($this, _get_value__a43j40(right, $this), _get_value__a43j40(smallest, $this)))
      smallest = right;
    if (!(smallest === i)) {
      swap_0($this, i, smallest);
      i = smallest;
    } else {
      break $l$loop;
    }
  }
}
function swap_0($this, l, r) {
  var temp = _get_value__a43j40(r, $this);
  _set_value__lx0xdg(r, $this, _get_value__a43j40(l, $this));
  _set_value__lx0xdg(l, $this, temp);
}
function _PriorityQueueNode___init__impl__34dlfu(index) {
  return index;
}
function _PriorityQueueNode___get_index__impl__b6r7i5($this) {
  return $this;
}
function Ref(value) {
  // Inline function 'kotlin.also' call
  var this_0 = Ref_0();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.Ref.<anonymous>' call
  this_0.j2r(value);
  return this_0;
}
function toRef(_this__u8e3s4) {
  return Ref_1(_this__u8e3s4);
}
function Ref_0() {
  return new Ref$1();
}
function Ref_1(prop) {
  return new Ref$2(prop);
}
function _TGenStack___init__impl__yynjgt(items) {
  items = items === VOID ? FastArrayList.sy() : items;
  return items;
}
function _get_items__fzd5gv($this) {
  return $this;
}
function _TGenStack___get_size__impl__cvg66t($this) {
  return _get_items__fzd5gv($this).e1();
}
function TGenStack__isEmpty_impl_bsbpyi($this) {
  return _TGenStack___get_size__impl__cvg66t($this) === 0;
}
var Companion_instance_9;
function Companion_getInstance_9() {
  return Companion_instance_9;
}
function TGenStack__push_impl_9yh33t($this, v) {
  _get_items__fzd5gv($this).h(v);
}
function TGenStack__pop_impl_qisxa0($this) {
  return _get_items__fzd5gv($this).p3(_get_items__fzd5gv($this).e1() - 1 | 0);
}
function TGenStack__clear_impl_pali4s($this) {
  _get_items__fzd5gv($this).l3();
}
function TGenStack__contains_impl_l8kli6($this, element) {
  return _get_items__fzd5gv($this).z2(element);
}
function TGenStack__contains_impl_l8kli6_0($this, element) {
  if (!(element == null ? true : !(element == null)))
    return false;
  return TGenStack__contains_impl_l8kli6($this.m2r_1, (element == null ? true : !(element == null)) ? element : THROW_CCE());
}
function TGenStack__containsAll_impl_ic9i7r($this, elements) {
  return _get_items__fzd5gv($this).a3(elements);
}
function TGenStack__containsAll_impl_ic9i7r_0($this, elements) {
  return TGenStack__containsAll_impl_ic9i7r($this.m2r_1, elements);
}
function TGenStack__iterator_impl_2pdia5($this) {
  return _get_items__fzd5gv($this).a1();
}
function TGenStack__toString_impl_s9t5hn($this) {
  return 'TGenStack(items=' + $this.toString() + ')';
}
function TGenStack__hashCode_impl_l04zom($this) {
  return $this.hashCode();
}
function TGenStack__equals_impl_w9i35u($this, other) {
  if (!(other instanceof TGenStack))
    return false;
  var tmp0_other_with_cast = other instanceof TGenStack ? other.m2r_1 : THROW_CCE();
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function contentHashCode_2(_this__u8e3s4, src, dst) {
  // Inline function 'korlibs.datastructure.internal.hashCoder' call
  var count = dst - src | 0;
  var out = 0;
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      out = imul(out, 7);
      var tmp = out;
      // Inline function 'korlibs.datastructure.internal.contentHashCode.<anonymous>' call
      out = tmp + toRawBits(_this__u8e3s4[src + n | 0]) | 0;
    }
     while (inductionVariable < count);
  return out;
}
function contentEquals_2(_this__u8e3s4, that, src, dst) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'korlibs.datastructure.internal.equaler' call
    var count = dst - src | 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.datastructure.internal.contentEquals.<anonymous>' call
        if (!(_this__u8e3s4[src + n | 0] === that[src + n | 0])) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
       while (inductionVariable < count);
    tmp$ret$1 = true;
  }
  return tmp$ret$1;
}
function contentHashCode_3(_this__u8e3s4, src, dst) {
  // Inline function 'korlibs.datastructure.internal.hashCoder' call
  var count = dst - src | 0;
  var out = 0;
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      out = imul(out, 7);
      var tmp = out;
      // Inline function 'korlibs.datastructure.internal.contentHashCode.<anonymous>' call
      out = tmp + _this__u8e3s4[src + n | 0] | 0;
    }
     while (inductionVariable < count);
  return out;
}
function contentEquals_3(_this__u8e3s4, that, src, dst) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'korlibs.datastructure.internal.equaler' call
    var count = dst - src | 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.datastructure.internal.contentEquals.<anonymous>' call
        if (!(_this__u8e3s4[src + n | 0] === that[src + n | 0])) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
       while (inductionVariable < count);
    tmp$ret$1 = true;
  }
  return tmp$ret$1;
}
function contentHashCode_4(_this__u8e3s4, src, dst) {
  // Inline function 'korlibs.datastructure.internal.hashCoder' call
  var count = dst - src | 0;
  var out = 0;
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      out = imul(out, 7);
      var tmp = out;
      // Inline function 'korlibs.datastructure.internal.contentHashCode.<anonymous>' call
      out = tmp + numberToInt(_this__u8e3s4[src + n | 0]) | 0;
    }
     while (inductionVariable < count);
  return out;
}
function contentEquals_4(_this__u8e3s4, that, src, dst) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'korlibs.datastructure.internal.equaler' call
    var count = dst - src | 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.datastructure.internal.contentEquals.<anonymous>' call
        if (!(_this__u8e3s4[src + n | 0] === that[src + n | 0])) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
       while (inductionVariable < count);
    tmp$ret$1 = true;
  }
  return tmp$ret$1;
}
function fill(_this__u8e3s4, value) {
  var inductionVariable = 0;
  var last = _this__u8e3s4.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      _this__u8e3s4[n] = value;
    }
     while (inductionVariable <= last);
}
function linkedHashMapOf(pairs) {
  // Inline function 'kotlin.also' call
  var this_0 = LinkedHashMap.gc();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.linkedHashMapOf.<anonymous>' call
  var inductionVariable = 0;
  var last = pairs.length;
  while (inductionVariable < last) {
    var _destruct__k2r9zo = pairs[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var key = _destruct__k2r9zo.jl();
    var value = _destruct__k2r9zo.kl();
    // Inline function 'kotlin.collections.set' call
    this_0.i3(key, value);
  }
  return this_0;
}
function _BSearchResult___init__impl__em6zam(raw) {
  return raw;
}
function _BSearchResult___get_raw__impl__uyuhf3($this) {
  return $this;
}
function _BSearchResult___get_found__impl__om04iz($this) {
  return _BSearchResult___get_raw__impl__uyuhf3($this) >= 0;
}
function _BSearchResult___get_index__impl__b5kraz($this) {
  return _BSearchResult___get_found__impl__om04iz($this) ? _BSearchResult___get_raw__impl__uyuhf3($this) : -1;
}
function _BSearchResult___get_nearIndex__impl__s8nq43($this) {
  return _BSearchResult___get_found__impl__om04iz($this) ? _BSearchResult___get_raw__impl__uyuhf3($this) : (-_BSearchResult___get_raw__impl__uyuhf3($this) | 0) - 1 | 0;
}
function binarySearch(_this__u8e3s4, v, fromIndex, toIndex) {
  fromIndex = fromIndex === VOID ? 0 : fromIndex;
  toIndex = toIndex === VOID ? _this__u8e3s4.e1() : toIndex;
  // Inline function 'korlibs.datastructure.genericBinarySearchResult' call
  var tmp$ret$1;
  $l$block: {
    // Inline function 'korlibs.datastructure.genericBinarySearch' call
    var low = fromIndex;
    var high = toIndex - 1 | 0;
    while (low <= high) {
      var mid = (low + high | 0) / 2 | 0;
      // Inline function 'korlibs.datastructure.binarySearch.<anonymous>' call
      var mval = compareTo(_this__u8e3s4.ux(mid), v);
      if (mval < 0)
        low = mid + 1 | 0;
      else if (mval > 0)
        high = mid - 1 | 0;
      else {
        tmp$ret$1 = mid;
        break $l$block;
      }
    }
    // Inline function 'korlibs.datastructure.genericBinarySearchResult.<anonymous>' call
    tmp$ret$1 = (-low | 0) - 1 | 0;
  }
  return _BSearchResult___init__impl__em6zam(tmp$ret$1);
}
function getCyclic(_this__u8e3s4, index) {
  return _this__u8e3s4.d1(umod(index, _this__u8e3s4.e1()));
}
function getCyclicOrNull(_this__u8e3s4, index) {
  return _this__u8e3s4.g1() ? null : getOrNull(_this__u8e3s4, umod(index, _this__u8e3s4.e1()));
}
function toLinkedMap(_this__u8e3s4) {
  // Inline function 'kotlin.also' call
  var this_0 = LinkedHashMap.gc();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.toLinkedMap.<anonymous>' call
  var _iterator__ex2g4s = _this__u8e3s4.a1();
  while (_iterator__ex2g4s.b1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.c1();
    var key = _destruct__k2r9zo.jl();
    var value = _destruct__k2r9zo.kl();
    // Inline function 'kotlin.collections.set' call
    this_0.i3(key, value);
  }
  return this_0;
}
function getCyclic_0(_this__u8e3s4, index) {
  return _this__u8e3s4[umod(index, _this__u8e3s4.length)];
}
function genericSort(subject, left, right, ops) {
  return genericSort_0(subject, left, right, ops, false);
}
function genericSort_0(subject, left, right, ops, reversed) {
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.genericSort.<anonymous>' call
  timSort(subject, left, right, ops, reversed);
  return subject;
}
function timSort(arr, l, r, ops, reversed, RUN) {
  RUN = RUN === VOID ? 32 : RUN;
  var n = (r - l | 0) + 1 | 0;
  var progression = step(until(0, n), RUN);
  var inductionVariable = progression.d2_1;
  var last = progression.e2_1;
  var step_0 = progression.f2_1;
  if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + step_0 | 0;
      var tmp = l + i | 0;
      // Inline function 'kotlin.math.min' call
      var a = (i + RUN | 0) - 1 | 0;
      var b = n - 1 | 0;
      var tmp$ret$0 = Math.min(a, b);
      insertionSort(arr, tmp, l + tmp$ret$0 | 0, ops, reversed);
    }
     while (!(i === last));
  var size = RUN;
  while (size < n) {
    var progression_0 = step(until(0, n), imul(2, size));
    var inductionVariable_0 = progression_0.d2_1;
    var last_0 = progression_0.e2_1;
    var step_1 = progression_0.f2_1;
    if (step_1 > 0 && inductionVariable_0 <= last_0 || (step_1 < 0 && last_0 <= inductionVariable_0))
      do {
        var left = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + step_1 | 0;
        // Inline function 'kotlin.math.min' call
        var a_0 = size;
        var b_0 = (n - left | 0) - 1 | 0;
        var rize = Math.min(a_0, b_0);
        var mid = (left + rize | 0) - 1 | 0;
        // Inline function 'kotlin.math.min' call
        var a_1 = (left + imul(2, rize) | 0) - 1 | 0;
        var b_1 = n - 1 | 0;
        var right = Math.min(a_1, b_1);
        merge(arr, l + left | 0, l + mid | 0, l + right | 0, ops, reversed);
      }
       while (!(left === last_0));
    size = imul(size, 2);
  }
}
function insertionSort(arr, left, right, ops, reversed) {
  var inductionVariable = left + 1 | 0;
  if (inductionVariable <= right)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var m = n - 1 | 0;
      $l$loop: while (m >= left && negateIf(ops.l2l(arr, m, n), reversed) > 0) {
        m = m - 1 | 0;
      }
      m = m + 1 | 0;
      if (!(m === n)) {
        ops.o2l(arr, m, n);
      }
    }
     while (!(n === right));
}
function merge(arr, start, mid, end, ops, reversed) {
  var s = start;
  var m = mid;
  var s2 = m + 1 | 0;
  if (negateIf(ops.l2l(arr, m, s2), reversed) <= 0)
    return Unit_instance;
  while (s <= m && s2 <= end) {
    if (negateIf(ops.l2l(arr, s, s2), reversed) <= 0) {
      s = s + 1 | 0;
    } else {
      ops.o2l(arr, s, s2);
      s = s + 1 | 0;
      m = m + 1 | 0;
      s2 = s2 + 1 | 0;
    }
  }
}
function negateIf(_this__u8e3s4, doNegate) {
  return doNegate ? -_this__u8e3s4 | 0 : _this__u8e3s4;
}
var Memory_instance;
function Memory_getInstance() {
  return Memory_instance;
}
var Companion_instance_10;
function Companion_getInstance_10() {
  return Companion_instance_10;
}
function index($this, index, offset) {
  return imul(index, 2) + offset | 0;
}
function pointArrayListOf(p0, p1) {
  return (new PointArrayList(2)).z2r(p0).z2r(p1);
}
function pointArrayListOf_0(p0, p1, p2) {
  return (new PointArrayList(3)).z2r(p0).z2r(p1).z2r(p2);
}
function pointArrayListOf_1(p0, p1, p2, p3) {
  return (new PointArrayList(4)).z2r(p0).z2r(p1).z2r(p2).z2r(p3);
}
function checkDimensions($this, dim) {
  if (!(dim === $this.f2s_1)) {
    // Inline function 'kotlin.error' call
    var message = 'Invalid dimensions ' + dim + ' != ' + $this.f2s_1;
    throw IllegalStateException.z4(toString(message));
  }
}
function DoubleVectorArrayList$vectorToStringBuilder$lambda(this$0, $index, $roundDecimalPlaces) {
  return function ($this$appendGenericArray, it) {
    var v = this$0.y27($index, it);
    appendNice($this$appendGenericArray, !($roundDecimalPlaces == null) ? roundDecimalPlaces(v, $roundDecimalPlaces) : v);
    return Unit_instance;
  };
}
var Companion_instance_11;
function Companion_getInstance_11() {
  return Companion_instance_11;
}
function FastStringMap() {
  // Inline function 'kotlin.js.asDynamic' call
  return new Map();
}
function FastIntMap() {
  // Inline function 'kotlin.js.asDynamic' call
  return new Map();
}
function get_size(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.size;
}
function FastIdentityMap() {
  // Inline function 'kotlin.js.asDynamic' call
  return new Map();
}
function contains_1(_this__u8e3s4, key) {
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.has(key);
}
function clear(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  _this__u8e3s4.clear();
}
function get_size_0(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.size;
}
function get_2(_this__u8e3s4, key) {
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.get(key);
}
function set_1(_this__u8e3s4, key, value) {
  // Inline function 'kotlin.js.asDynamic' call
  _this__u8e3s4.set(key, value);
}
function remove(_this__u8e3s4, key) {
  // Inline function 'kotlin.js.asDynamic' call
  _this__u8e3s4.delete(key);
}
function keys(_this__u8e3s4) {
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = Array_from(_this__u8e3s4.keys());
  return toList_0(tmp$ret$2);
}
function Array_from(value) {
  return Array.from(value);
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForInterface(IArray2, 'IArray2', VOID, VOID, [Iterable]);
initMetadataForInterface(IntIArray2, 'IntIArray2', VOID, VOID, [IArray2]);
protoOf(IntArray2).y27 = get;
protoOf(IntArray2).f2j = set;
protoOf(IntArray2).ux = getAt_0;
protoOf(IntArray2).g2j = getAt;
protoOf(IntArray2).h2j = inside;
protoOf(IntArray2).e2j = asString;
initMetadataForClass(IntArray2, 'IntArray2', VOID, VOID, [IntIArray2]);
initMetadataForCompanion(Companion_0);
initMetadataForInterface(FloatIArray2, 'FloatIArray2', VOID, VOID, [IArray2]);
protoOf(FloatArray2).y27 = get_0;
protoOf(FloatArray2).m2j = set_0;
protoOf(FloatArray2).ux = getAt_1;
protoOf(FloatArray2).g2j = getAt;
protoOf(FloatArray2).h2j = inside;
protoOf(FloatArray2).e2j = asString;
initMetadataForClass(FloatArray2, 'FloatArray2', VOID, VOID, [FloatIArray2]);
initMetadataForCompanion(Companion_1);
initMetadataForClass(FloatArrayList, 'FloatArrayList', FloatArrayList.p2j, VOID, [Collection]);
initMetadataForCompanion(Companion_2);
initMetadataForClass(IntArrayList, 'IntArrayList', IntArrayList.a2k, VOID, [Collection]);
initMetadataForCompanion(Companion_3);
protoOf(DoubleArrayList).b3 = listIterator;
initMetadataForClass(DoubleArrayList, 'DoubleArrayList', DoubleArrayList.w2k, VOID, [DoubleList]);
initMetadataForClass(SortOps, 'SortOps');
initMetadataForObject(DoubleArrayListSortOps, 'DoubleArrayListSortOps');
initMetadataForClass(TGenDeque$iterator$1);
initMetadataForClass(TGenDeque, 'TGenDeque', TGenDeque.x2l, VOID, [Collection, MutableIterable]);
initMetadataForClass(IntDeque$iterator$1);
initMetadataForClass(IntDeque, 'IntDeque', IntDeque.u2m, VOID, [Collection, MutableIterable]);
initMetadataForClass(FastSmallSet, 'FastSmallSet', FastSmallSet.f2n);
initMetadataForClass(GenericSubList, 'GenericSubList', VOID, VOID, [KtList]);
initMetadataForClass(GenericListIterator, 'GenericListIterator');
initMetadataForClass(HistoryStack, 'HistoryStack', HistoryStack);
initMetadataForCompanion(Companion_4);
initMetadataForCompanion(Companion_5);
initMetadataForClass(Entry, 'Entry');
initMetadataForClass(Iterator, 'Iterator');
initMetadataForClass(_no_name_provided__qut3iv, VOID, VOID, VOID, [Iterable]);
initMetadataForClass(_no_name_provided__qut3iv_0, VOID, VOID, VOID, [Iterable]);
initMetadataForClass(IntMap, 'IntMap', IntMap.v2o);
initMetadataForCompanion(Companion_6);
initMetadataForClass(IntIntMap, 'IntIntMap', IntIntMap.n2p);
initMetadataForClass(Iterator$1);
initMetadataForClass(ListReader, 'ListReader');
initMetadataForCompanion(Companion_7);
initMetadataForClass(Pool, 'Pool');
initMetadataForClass(ConcurrentPool, 'ConcurrentPool');
initMetadataForClass(ReturnablePool, 'ReturnablePool');
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForCompanion(Companion_8);
initMetadataForClass(TGenPriorityQueue$iterator$1);
initMetadataForClass(TGenPriorityQueue, 'TGenPriorityQueue', VOID, VOID, [Collection, MutableIterable]);
initMetadataForClass(TGenQueue, 'TGenQueue', TGenQueue, VOID, [Collection]);
initMetadataForClass(Ref$1);
initMetadataForClass(Ref$2);
initMetadataForCompanion(Companion_9);
initMetadataForClass(TGenStack, 'TGenStack', VOID, VOID, [Collection]);
initMetadataForClass(SyncPauseable, 'SyncPauseable', SyncPauseable);
initMetadataForObject(Memory, 'Memory');
initMetadataForInterface(PointList, 'PointList', VOID, VOID, [IDoubleVectorList, IPointList]);
initMetadataForCompanion(Companion_10);
protoOf(PointArrayList).x2r = clone$default;
protoOf(PointArrayList).a28 = get_dimensions;
protoOf(PointArrayList).g1 = isEmpty;
protoOf(PointArrayList).q2r = getComponentList;
protoOf(PointArrayList).r2r = getComponentList$default;
protoOf(PointArrayList).d2m = get_first;
protoOf(PointArrayList).e2m = get_last;
protoOf(PointArrayList).s27 = contains;
protoOf(PointArrayList).o2e = contains_0;
protoOf(PointArrayList).x27 = isNotEmpty;
protoOf(PointArrayList).z27 = isAlmostEquals;
protoOf(PointArrayList).fx = isAlmostEquals$default;
protoOf(PointArrayList).q27 = containsAll;
protoOf(PointArrayList).o27 = indexOf;
protoOf(PointArrayList).a1 = iterator;
protoOf(PointArrayList).b3 = listIterator_0;
protoOf(PointArrayList).i1 = listIterator_1;
protoOf(PointArrayList).c3 = subList;
initMetadataForClass(PointArrayList, 'PointArrayList', PointArrayList, VOID, [PointList]);
protoOf(DoubleVectorArrayList).z27 = isAlmostEquals;
protoOf(DoubleVectorArrayList).fx = isAlmostEquals$default;
initMetadataForClass(DoubleVectorArrayList, 'DoubleVectorArrayList', VOID, VOID, [IDoubleVectorList]);
initMetadataForCompanion(Companion_11);
initMetadataForClass(PointIntArrayList, 'PointIntArrayList', PointIntArrayList);
//endregion
//region block: init
Companion_instance = new Companion();
Companion_instance_0 = new Companion_0();
Companion_instance_1 = new Companion_1();
Companion_instance_2 = new Companion_2();
Companion_instance_3 = new Companion_3();
Companion_instance_4 = new Companion_4();
Companion_instance_5 = new Companion_5();
Companion_instance_6 = new Companion_6();
Companion_instance_7 = new Companion_7();
Companion_instance_8 = new Companion_8();
Companion_instance_9 = new Companion_9();
Memory_instance = new Memory();
Companion_instance_10 = new Companion_10();
Companion_instance_11 = new Companion_11();
//endregion
//region block: exports
export {
  _BSearchResult___init__impl__em6zam as _BSearchResult___init__impl__em6zam3kgjdixysmohf,
  _BSearchResult___get_found__impl__om04iz as _BSearchResult___get_found__impl__om04iz3bh6o9yjop0o,
  _BSearchResult___get_index__impl__b5kraz as _BSearchResult___get_index__impl__b5kraz2d2rlh08ytgci,
  _BSearchResult___get_nearIndex__impl__s8nq43 as _BSearchResult___get_nearIndex__impl__s8nq431w00iur5bsqs2,
  _TGenStack___init__impl__yynjgt as _TGenStack___init__impl__yynjgt2kqnbzr6sil9y,
  TGenStack__pop_impl_qisxa0 as TGenStack__pop_impl_qisxa01c9hqlgdxaps5,
  TGenStack__push_impl_9yh33t as TGenStack__push_impl_9yh33t21dxxdiycat5m,
  Companion_instance_0 as Companion_instance3ldriv9x4zcjm,
  Companion_instance as Companion_instancelqpzd9anuk16,
  Companion_instance_8 as Companion_instance2r8kc48nhvjcq,
  SyncPauseable as SyncPauseable20rt0nt3umu2s,
  ConcurrentPool as ConcurrentPool3ky1e4r5za9ab,
  DoubleArrayList as DoubleArrayList3by0we6lhx26x,
  FastIdentityMap as FastIdentityMap17d14y8i3m5g7,
  FastIntMap as FastIntMapl0pzyavg6uw5,
  FastSmallSet as FastSmallSet2og2j8v2pz4c7,
  FastStringMap as FastStringMap1l1uzdhsfbatm,
  FloatArray2 as FloatArray2beehiaucxmzd,
  GenericListIterator as GenericListIterator397gjg9p2xwl5,
  GenericSubList as GenericSubList2rec7qqyf06nw,
  HistoryStack as HistoryStack2mrikkhc0etuj,
  IntArray2 as IntArray23680o40e0fgt8,
  IntArrayList as IntArrayList3liuagbdnwmna,
  IntDeque as IntDeque2ebok66x2sofm,
  IntIntMap as IntIntMap3mvg5iqgd5t3z,
  IntMap as IntMap2d9g6f5pyaoc2,
  ListReader as ListReader37jxep6q6wbzq,
  Pool as Pool1zbsw0zhvh8ca,
  Ref_0 as Ref11k43t82thcp3,
  Ref as Ref2y4j4snnxo6gs,
  ReturnablePool as ReturnablePool3rkgvxsckx2u2,
  SortOps as SortOps3rp25tm4jbjru,
  TGenDeque as TGenDeque2zx9g0ftfbw19,
  TGenQueue as TGenQueue2v9j3ju90xgpv,
  associateByInt as associateByInt3vmv30txx5avl,
  binarySearch as binarySearch1lxbagta5e4q4,
  clear as clear3idbm40uzyume,
  contains_1 as containsrsn76oa0puwr,
  doubleArrayListOf as doubleArrayListOfkj3z9zq4pobs,
  floatArrayListOf as floatArrayListOfa8snvg2p0fhc,
  genericSort as genericSort3vhmyxbppxo3h,
  getAndRemove as getAndRemove1ksxnnren48mb,
  getCyclicOrNull as getCyclicOrNull12fem85bj0m7u,
  getCyclic_0 as getCyclic18d9063nmuul,
  getCyclic as getCyclic28wvgqye98jqx,
  get_2 as get2pw1zlgv5zypd,
  intArrayListOf as intArrayListOf18h0hna7wb0zr,
  get_keys as get_keyswqddktl7cnu2,
  linkedHashMapOf as linkedHashMapOf2w2uhgrq4khrk,
  reverse_0 as reverse22fe0u1pwl2c6,
  rotateRight as rotateRight96vk8nw2c6nx,
  set_1 as set2vuztm9k7ubgo,
  get_size_0 as get_size2tttv7g2u748n,
  get_size as get_size3oaoh8cpamcqc,
  sort as sort23bpsawysis6n,
  swap as swap3upf401qn4fc8,
  toDeque as toDeque2gx2crptp8sro,
  toIntArrayList as toIntArrayList3jlt4o6tyleu,
  toIntMap as toIntMapp1jij98esrcm,
  toRef as toRef3av6zm8yavumw,
  DoubleVectorArrayList as DoubleVectorArrayListq54dfthnqi2t,
  PointArrayList as PointArrayList281mrsgyr6ua1,
  PointIntArrayList as PointIntArrayList1s7gare9hr1oh,
  pointArrayListOf_1 as pointArrayListOf36sb9r6prgwk4,
  pointArrayListOf_0 as pointArrayListOf2s9je3njyg83l,
  pointArrayListOf as pointArrayListOf7rbgdbqf3x4b,
};
//endregion
